(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-animation-coverage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-animation-coverage';
    const ROOT_SELECTOR = '[data-ndev-animation-coverage]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function clamp01(n) {
      if (n <= 0) return 0;
      if (n >= 1) return 1;
      return n;
    }

    function parseNumber(v, fallback) {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : fallback;
    }

    function toPx(value, unit, viewportHeight) {
      if (unit === 'percent') return (value / 100) * viewportHeight;
      return value;
    }

    function computeProgress(elementTopPx, startPx, endPx) {
      const denom = (startPx - endPx);
      if (!denom) {
        if (elementTopPx <= endPx) return 1;
        return 0;
      }
      return clamp01((startPx - elementTopPx) / denom);
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const items = Array.prototype.slice.call(root.querySelectorAll('[data-ndev-scroll-opacity]'));
      let rafId = 0;
      let destroyed = false;

      function update() {
        rafId = 0;
        if (destroyed) return;

        const vh = window.innerHeight || document.documentElement.clientHeight || 0;
        for (let i = 0; i < items.length; i++) {
          const el = items[i];
          if (!el || !el.getBoundingClientRect) continue;

          const rect = el.getBoundingClientRect();
          const elementBottom = rect.bottom;

          const unit = el.dataset.scrollUnit || 'percent';
          const startVal = parseNumber(el.dataset.scrollStart, 80);
          const endVal = parseNumber(el.dataset.scrollEnd, 30);
          const fromOpacity = clamp01(parseNumber(el.dataset.scrollFromOpacity, 0));

          const startPx = toPx(startVal, unit, vh);
          const endPx = toPx(endVal, unit, vh);
          const p = computeProgress(elementBottom, startPx, endPx);

          const opacity = fromOpacity + (1 - fromOpacity) * p;
          el.style.opacity = String(opacity);
        }
      }

      function scheduleUpdate() {
        if (rafId) return;
        rafId = window.requestAnimationFrame(update);
      }

      function onScroll() { scheduleUpdate(); }
      function onResize() { scheduleUpdate(); }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);

      scheduleUpdate();

      controllers.set(root, {
        root: root,
        destroy: function () {
          destroyed = true;
          try { window.removeEventListener('scroll', onScroll); } catch (e) {}
          try { window.removeEventListener('resize', onResize); } catch (e) {}
          try { if (rafId) window.cancelAnimationFrame(rafId); } catch (e) {}
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class NdevAnnouncementBar extends BaseElement {
    init() {
      this.dispose();

      this.listeners = [];
      this.index = 0;
      this.timer = null;
      this.closeTimer = null;
      this.pauseReasons = new Set();
      this.inView = true;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplayEnabled = this.getAttribute('autoplay') === 'true';
      this.autoplaySpeed = Math.min(10000, Math.max(2000, Number(this.getAttribute('autoplay-speed')) || 5000));
      this.fingerprint = this.getAttribute('fingerprint') || '';
      this.isDesignMode = Boolean(window.Shopify?.designMode);
      this.removeAttribute('hidden');

      try {
        if (!this.isDesignMode && this.fingerprint && sessionStorage.getItem('ndev-announcement-bar:closed') === this.fingerprint) {
          this.setAttribute('hidden', '');
          return;
        }
      } catch (error) {}

      this.viewport = this.querySelector('.ndev-announcement-bar__viewport');
      this.track = this.querySelector('.ndev-announcement-bar__track');
      this.slides = Array.from(this.querySelectorAll('.ndev-announcement-bar__slide'));
      this.status = this.querySelector('.ndev-announcement-bar__status');
      this.closeButton = this.querySelector('.ndev-announcement-bar__close');
      this.prevButton = this.querySelector('.ndev-announcement-bar__arrow--prev');
      this.nextButton = this.querySelector('.ndev-announcement-bar__arrow--next');

      if (!this.viewport || !this.track || this.slides.length === 0) return;

      this.updateSlideLayers(this.index, (this.index + 1) % this.slides.length);

      this.on(this, 'click', (event) => this.handleBarClick(event));
      if (this.closeButton) this.on(this.closeButton, 'click', (event) => this.handleClose(event));

      if (this.motionQuery.addEventListener) {
        this.on(this.motionQuery, 'change', () => this.handleMotionChange());
      }

      if (this.slides.length > 1) {
        if (this.prevButton) this.on(this.prevButton, 'click', () => this.goTo(this.index - 1, true));
        if (this.nextButton) this.on(this.nextButton, 'click', () => this.goTo(this.index + 1, true));
        this.on(this, 'mouseenter', () => this.pause('hover'));
        this.on(this, 'mouseleave', () => this.resume('hover'));
        this.on(this, 'focusin', () => this.pause('focus'));
        this.on(this, 'focusout', () => this.resume('focus'));
        this.on(document, 'visibilitychange', () => this.syncAutoplay());
        this.on(document, 'shopify:block:select', (event) => this.handleBlockSelect(event));
        this.on(document, 'shopify:block:deselect', (event) => this.handleBlockDeselect(event));
        this.observeVisibility();
      }

      this.setAttribute('ready', '');
      this.updateSlides();
      this.updateClickable();
      this.syncAutoplay();
    }

    dispose() {
      clearTimeout(this.timer);
      clearTimeout(this.closeTimer);
      this.timer = null;
      this.closeTimer = null;

      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      this.intersectionObserver = null;

      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler, options }) => {
          target.removeEventListener(type, handler, options);
        });
      }
      this.listeners = [];

      if (this.slides) {
        this.slides.forEach((slide) => {
          slide.removeAttribute('aria-hidden');
          slide.inert = false;
          slide.classList.remove('is-active', 'is-next', 'is-other', 'is-exiting');
        });
      }
      this.classList.remove('is-closing', 'has-url');
      this.removeAttribute('ready');
    }

    on(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      this.listeners.push({ target, type, handler, options });
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) return;
      this.intersectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        this.inView = Boolean(entry && entry.isIntersecting);
        this.syncAutoplay();
      }, { threshold: 0 });
      this.intersectionObserver.observe(this);
    }

    goTo(index, manual) {
      const count = this.slides.length;
      if (count === 0) return;
      const nextIndex = ((index % count) + count) % count;
      if (nextIndex === this.index) return;

      const previousIndex = this.index;
      this.index = nextIndex;
      this.updateSlideLayers(nextIndex, (nextIndex + 1) % count, previousIndex);
      this.updateSlides();
      this.updateClickable();
      if (manual) this.syncAutoplay();
      if (manual) this.announceSlide();
    }

    announceSlide() {
      if (!this.status) return;
      const slide = this.slides[this.index];
      const text = slide ? slide.textContent.replace(/\s+/g, ' ').trim() : '';
      this.status.textContent = text
        ? `${this.index + 1} of ${this.slides.length}: ${text}`
        : `${this.index + 1} of ${this.slides.length}`;
    }

    updateSlides() {
      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.index;
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.inert = !isActive;
      });
    }

    updateSlideLayers(activeIndex, nextIndex, previousIndex) {
      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
        slide.classList.toggle('is-exiting', slideIndex === previousIndex && slideIndex !== activeIndex);
        slide.classList.toggle('is-next', slideIndex === nextIndex && slideIndex !== activeIndex && slideIndex !== previousIndex);
        slide.classList.toggle('is-other', slideIndex !== activeIndex && slideIndex !== nextIndex && slideIndex !== previousIndex);
      });
    }

    updateClickable() {
      const slide = this.slides[this.index];
      const link = slide ? slide.querySelector('.ndev-announcement-bar__slide-link') : null;
      this.classList.toggle('has-url', Boolean(link));
    }

    isAutoplayRunning() {
      return this.autoplayEnabled
        && this.slides.length > 1
        && !this.motionQuery.matches
        && this.pauseReasons.size === 0
        && this.inView
        && !document.hidden;
    }

    syncAutoplay() {
      clearTimeout(this.timer);
      this.timer = null;
      if (!this.isAutoplayRunning()) return;
      this.timer = setTimeout(() => {
        this.goTo(this.index + 1, false);
        this.syncAutoplay();
      }, this.autoplaySpeed);
    }

    pause(reason) {
      this.pauseReasons.add(reason);
      this.syncAutoplay();
    }

    resume(reason) {
      this.pauseReasons.delete(reason);
      this.syncAutoplay();
    }

    handleMotionChange() {
      this.syncAutoplay();
    }

    handleBarClick(event) {
      if (event.target.closest('a, button')) return;
      const slide = this.slides[this.index];
      const link = slide ? slide.querySelector('.ndev-announcement-bar__slide-link') : null;
      if (link) link.click();
    }

    handleClose(event) {
      event.stopPropagation();

      if (!this.isDesignMode) {
        try {
          sessionStorage.setItem('ndev-announcement-bar:closed', this.fingerprint);
        } catch (error) {}
      }

      this.dispatchEvent(new CustomEvent('ndev:announcement-bar-closed', { bubbles: true }));

      clearTimeout(this.timer);
      this.timer = null;

      if (this.motionQuery.matches) {
        this.setAttribute('hidden', '');
        return;
      }

      this.classList.add('is-closing');
      this.closeTimer = setTimeout(() => {
        this.setAttribute('hidden', '');
        this.classList.remove('is-closing');
      }, 260);
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;
      const slide = event.target.closest('.ndev-announcement-bar__slide');
      const slideIndex = this.slides.indexOf(slide);
      if (slideIndex < 0) return;
      this.pause('editor');
      this.goTo(slideIndex, false);
    }

    handleBlockDeselect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;
      this.resume('editor');
    }
  }

  if (!customElements.get('ndev-announcement-bar')) {
    customElements.define('ndev-announcement-bar', NdevAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-ax26-coverage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-ax26-coverage';
    const ROOT_SELECTOR = '[data-ndev-ax26-coverage]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function clamp01(n) {
      if (n <= 0) return 0;
      if (n >= 1) return 1;
      return n;
    }

    function parseNumber(v, fallback) {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : fallback;
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const masks = Array.prototype.slice.call(root.querySelectorAll('[data-ndev-ax26-coverage-mask]'));
      const stickyEl = root.querySelector('.ndev-ax26-coverage');
      let rafId = 0;
      let destroyed = false;
      let lastProgress = -1;
      let lastTextProgress = -1;

      // 从 wrapper 的 CSS 变量读取行程
      const travelDistanceVh = parseNumber(getComputedStyle(root).getPropertyValue('--wrapper-height'), 300) - 100;
      const textTravelShare = Math.min(
        1,
        Math.max(0.08, parseNumber(getComputedStyle(root).getPropertyValue('--coverage-text-travel-ratio'), 0.32))
      );

      function update() {
        rafId = 0;
        if (destroyed) return;

        const vh = window.innerHeight || document.documentElement.clientHeight || 0;
        const scrollTop = window.scrollY || window.pageYOffset || 0;
        const rect = root.getBoundingClientRect();
        const wrapperTopPx = rect.top + scrollTop;

        const travelPx = (travelDistanceVh / 100) * vh;
        const scrollDistance = scrollTop - wrapperTopPx;
        const progress = 1 - clamp01(scrollDistance / travelPx);

        const textTravelPx = travelPx * textTravelShare;
        const textProgress = 1 - clamp01(scrollDistance / textTravelPx);

        // 变化检测：值未变时跳过 DOM 写入，减少 style recalc
        if (Math.abs(textProgress - lastTextProgress) >= 0.001) {
          lastTextProgress = textProgress;
          stickyEl.style.setProperty('--coverage-text-scroll-progress', String(textProgress));
        }
        if (Math.abs(progress - lastProgress) >= 0.001) {
          lastProgress = progress;
          for (let i = 0; i < masks.length; i++) {
            const mask = masks[i];
            if (!mask) continue;
            mask.style.setProperty('--mask-opacity', progress);
          }
        }
      }

      function scheduleUpdate() {
        if (rafId) return;
        rafId = window.requestAnimationFrame(update);
      }

      function onScroll() {
        scheduleUpdate();
      }

      function onResize() {
        scheduleUpdate();
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      scheduleUpdate();

      controllers.set(root, {
        root: root,
        destroy: function () {
          destroyed = true;
          stickyEl.style.removeProperty('--coverage-text-scroll-progress');
          try { window.removeEventListener('scroll', onScroll); } catch (e) {}
          try { window.removeEventListener('resize', onResize); } catch (e) {}
          try { if (rafId) window.cancelAnimationFrame(rafId); } catch (e) {}
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-brand-trust-marquee"] && !Shopify.designMode) return;
  try {
    
  class NdevBrandTrustMarquee extends BaseElement {
    init() {
      this.dispose();

      this.viewport = this.querySelector('.ndev-brand-trust-marquee__viewport');
      this.track = this.querySelector('.ndev-brand-trust-marquee__track');
      this.originalGroup = this.querySelector('.ndev-brand-trust-marquee__group:not(.ndev-brand-trust-marquee__group--clone)');
      this.listeners = [];
      this.clones = [];
      this.offset = 0;
      this.period = 0;
      this.maxOverflow = 0;
      this.lastTimestamp = null;
      this.animationFrame = null;
      this.measureFrame = null;
      this.dragging = false;
      this.dragPointerId = null;
      this.pointerMoved = false;
      this.userPaused = false;
      this.editorPaused = false;
      this.inView = !('IntersectionObserver' in window);
      this.autoplayEnabled = this.getAttribute('autoplay') === 'true';
      this.speed = Math.max(0, Number(this.getAttribute('speed')) || 30);
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.viewport || !this.track || !this.originalGroup) return;

      this.on(document, 'visibilitychange', () => this.syncRuntimeState());
      this.on(document, 'shopify:block:select', (event) => this.handleBlockSelect(event));
      this.on(document, 'shopify:block:deselect', (event) => this.handleBlockDeselect(event));
      this.on(this.viewport, 'keydown', (event) => this.handleKeyDown(event));
      this.on(this.viewport, 'pointerdown', (event) => this.handlePointerDown(event));
      this.on(this.viewport, 'pointermove', (event) => this.handlePointerMove(event));
      this.on(this.viewport, 'pointerup', (event) => this.endDrag(event));
      this.on(this.viewport, 'pointercancel', (event) => this.endDrag(event));
      this.on(this.viewport, 'lostpointercapture', (event) => this.endDrag(event));

      if (this.motionQuery.addEventListener) {
        this.on(this.motionQuery, 'change', () => this.handleMotionChange());
      } else if (this.motionQuery.addListener) {
        this.motionListener = () => this.handleMotionChange();
        this.motionQuery.addListener(this.motionListener);
      }

      this.observeVisibility();
      this.observeSize();
      this.scheduleMeasure();
      this.updateInteractionMetadata();
    }

    dispose() {
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      if (this.measureFrame) cancelAnimationFrame(this.measureFrame);
      this.animationFrame = null;
      this.measureFrame = null;

      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      this.intersectionObserver = null;
      this.resizeObserver = null;

      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler, options }) => {
          target.removeEventListener(type, handler, options);
        });
      }
      this.listeners = [];

      if (this.motionListener && this.motionQuery?.removeListener) {
        this.motionQuery.removeListener(this.motionListener);
      }
      this.motionListener = null;

      if (this.viewport && this.dragPointerId !== null && this.viewport.hasPointerCapture?.(this.dragPointerId)) {
        this.viewport.releasePointerCapture(this.dragPointerId);
      }

      this.querySelectorAll('.ndev-brand-trust-marquee__group--clone').forEach((clone) => clone.remove());
      this.clones = [];
      this.period = 0;
      this.maxOverflow = 0;
      this.offset = 0;
      this.dragging = false;
      this.dragPointerId = null;
      this.pointerMoved = false;
      this.editorPaused = false;
      this.userPaused = false;
      if (this.track) this.track.style.removeProperty('transform');
      if (this.viewport) this.viewport.scrollLeft = 0;
      this.classList.remove('is-draggable', 'is-dragging', 'is-user-paused');
      this.removeAttribute('ready');
    }

    on(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      this.listeners.push({ target, type, handler, options });
    }

    isLoopMode() {
      return this.autoplayEnabled && this.speed > 0 && !this.motionQuery.matches && this.period > 0;
    }

    isDraggable() {
      return this.isLoopMode() || this.maxOverflow > 0;
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) return;
      this.intersectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        this.inView = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0);
        this.syncRuntimeState();
      }, { threshold: [0, 0.01] });
      this.intersectionObserver.observe(this);
    }

    observeSize() {
      if (!('ResizeObserver' in window)) return;
      this.resizeObserver = new ResizeObserver(() => this.scheduleMeasure());
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.originalGroup);
    }

    scheduleMeasure() {
      if (this.measureFrame) cancelAnimationFrame(this.measureFrame);
      this.measureFrame = requestAnimationFrame(() => {
        this.measureFrame = null;
        this.rebuildTrack();
      });
    }

    rebuildTrack() {
      this.removeClones();
      this.period = this.originalGroup.getBoundingClientRect().width;
      this.maxOverflow = Math.max(0, this.period - this.getViewportContentWidth());

      if (this.isLoopMode()) {
        const cloneCount = Math.max(1, Math.ceil(this.viewport.clientWidth / this.period) + 1);
        for (let index = 0; index < cloneCount; index += 1) {
          const clone = this.originalGroup.cloneNode(true);
          clone.classList.add('ndev-brand-trust-marquee__group--clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          this.sanitizeClone(clone);
          this.track.appendChild(clone);
          this.clones.push(clone);
        }
        this.offset = this.normalizeOffset(this.offset);
      } else {
        this.offset = this.clampOffset(this.offset);
      }

      this.viewport.scrollLeft = 0;
      this.applyOffset();
      this.setAttribute('ready', '');
      this.updateDraggableState();
      this.updateInteractionMetadata();
      this.syncRuntimeState();
    }

    getViewportContentWidth() {
      const styles = getComputedStyle(this.viewport);
      const padding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
      return Math.max(0, this.viewport.clientWidth - padding);
    }

    removeClones() {
      this.clones.forEach((clone) => clone.remove());
      this.clones = [];
    }

    sanitizeClone(clone) {
      [clone, ...clone.querySelectorAll('*')].forEach((element) => {
        element.removeAttribute('id');
        Array.from(element.attributes).forEach((attribute) => {
          if (attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
        });
      });
    }

    normalizeOffset(value) {
      if (this.period <= 0) return 0;
      return ((value % this.period) + this.period) % this.period;
    }

    clampOffset(value) {
      return Math.min(this.maxOverflow, Math.max(0, value));
    }

    applyOffset() {
      if (!this.track) return;
      this.track.style.transform = 'translate3d(' + (-this.offset) + 'px, 0, 0)';
    }

    updateDraggableState() {
      this.classList.toggle('is-draggable', this.isDraggable());
    }

    syncRuntimeState() {
      const shouldRun = this.isLoopMode()
        && !this.userPaused
        && !this.editorPaused
        && !this.dragging
        && this.inView
        && !document.hidden;

      if (shouldRun) {
        if (!this.animationFrame) this.animationFrame = requestAnimationFrame((timestamp) => this.tick(timestamp));
      } else {
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
        this.lastTimestamp = null;
      }

      this.updateInteractionMetadata();
    }

    tick(timestamp) {
      this.animationFrame = null;
      if (this.lastTimestamp !== null) {
        const elapsed = Math.min(64, timestamp - this.lastTimestamp) / 1000;
        this.offset = this.normalizeOffset(this.offset + this.speed * elapsed);
        this.applyOffset();
      }
      this.lastTimestamp = timestamp;
      this.syncRuntimeState();
    }

    handleKeyDown(event) {
      if (event.key !== 'Escape' || !this.isLoopMode()) return;
      event.preventDefault();
      this.toggleUserPaused();
    }

    handlePointerDown(event) {
      if (!this.isDraggable()) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      this.dragging = true;
      this.dragPointerId = event.pointerId;
      this.dragStartX = event.clientX;
      this.dragStartOffset = this.offset;
      this.pointerMoved = false;
      this.lastTimestamp = null;
      this.classList.add('is-dragging');
      this.viewport.setPointerCapture(event.pointerId);
      this.syncRuntimeState();
    }

    handlePointerMove(event) {
      if (!this.dragging || event.pointerId !== this.dragPointerId) return;
      const deltaX = event.clientX - this.dragStartX;
      if (Math.abs(deltaX) > 6) this.pointerMoved = true;
      const nextOffset = this.dragStartOffset - deltaX;
      this.offset = this.isLoopMode() ? this.normalizeOffset(nextOffset) : this.clampOffset(nextOffset);
      this.applyOffset();
      if (this.pointerMoved && event.cancelable) event.preventDefault();
    }

    endDrag(event) {
      if (!this.dragging || event.pointerId !== this.dragPointerId) return;

      this.dragging = false;
      this.dragPointerId = null;
      this.pointerMoved = false;
      this.classList.remove('is-dragging');

      this.syncRuntimeState();
    }

    toggleUserPaused() {
      if (!this.isLoopMode()) return;
      this.userPaused = !this.userPaused;
      this.classList.toggle('is-user-paused', this.userPaused);
      this.syncRuntimeState();
    }

    updateInteractionMetadata() {
      if (!this.viewport) return;

      let label = 'Brand trust statistics. Drag to browse.';
      if (this.isLoopMode()) {
        label = this.userPaused
          ? 'Brand trust statistics. Autoplay paused. Press Escape to resume; drag to browse.'
          : 'Brand trust statistics. Press Escape to pause; drag to browse.';
      }

      this.viewport.setAttribute('aria-label', label);
      this.viewport.setAttribute('title', label);
    }

    handleMotionChange() {
      if (this.viewport && this.dragPointerId !== null && this.viewport.hasPointerCapture?.(this.dragPointerId)) {
        this.viewport.releasePointerCapture(this.dragPointerId);
      }
      this.dragging = false;
      this.dragPointerId = null;
      this.pointerMoved = false;
      this.classList.remove('is-dragging');
      this.scheduleMeasure();
      this.syncRuntimeState();
    }

    findOriginalHost(target) {
      let current = target instanceof Element ? target : target?.parentElement;
      while (current && current !== this.originalGroup) {
        if (current.parentElement === this.originalGroup) return current;
        current = current.parentElement;
      }
      return null;
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;
      const host = this.findOriginalHost(event.target);
      if (!host) return;

      this.editorPaused = true;
      this.offset = this.isLoopMode()
        ? this.normalizeOffset(host.offsetLeft)
        : this.clampOffset(host.offsetLeft);
      this.applyOffset();
      this.syncRuntimeState();
    }

    handleBlockDeselect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;
      this.editorPaused = false;
      this.syncRuntimeState();
    }
  }

  if (!customElements.get('ndev-brand-trust-marquee')) {
    customElements.define('ndev-brand-trust-marquee', NdevBrandTrustMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-category-navbar"] && !Shopify.designMode) return;
  try {
    
  class NdevCategoryNavbar extends HTMLElement {
    static LOCK_IDLE_MS = 220; // 停止滚动多久后解锁
    static LOCK_MAX_MS = 6000; // 最大锁定时间兜底，避免极端情况锁死

    connectedCallback() {
      this._headerEl = document.querySelector('#site-header');
      this._sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section, #main-content .shopify-section'));
      this._container = this.querySelector('.ndev-category-navbar__container');
      this._wrapper = this.closest('.ndev-category-navbar-section');
      this._activeItem = this.querySelector('[data-ndev-category-navbar-item].is-active');
      this._lock = null;
      this._naturalTop = null;
      this._ticking = false;

      const mainContent = document.querySelector('#MainContent, #main-content');
      if (mainContent && window.MutationObserver) {
        this._sectionsObserver = new MutationObserver(() => {
          this._sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section, #main-content .shopify-section'));
        });
        this._sectionsObserver.observe(mainContent, { childList: true });
      }

      // 收集所有锚点导航项，构建 section index → 导航项映射
      this._anchorItemMap = {};
      this.querySelectorAll('[data-ndev-category-navbar-item]').forEach((el) => {
        if (el.getAttribute('data-item-type') !== 'anchor') return;
        const ai = parseInt(el.getAttribute('data-anchor-index') || '', 10);
        if (ai) this._anchorItemMap[ai] = el;
      });
      this._anchorKeys = Object.keys(this._anchorItemMap)
        .map(Number)
        .sort((a, b) => a - b);

      this._onScroll = this._onScroll.bind(this);
      this._onClickCapture = this._onClickCapture.bind(this);

      this.addEventListener('click', this._onClickCapture);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });

      this._onScroll();
    }

    disconnectedCallback() {
      this._clearLock();
      this.removeEventListener('click', this._onClickCapture);
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      if (this._sectionsObserver) this._sectionsObserver.disconnect();
      if (this._wrapper) this._wrapper.classList.remove('is-stuck');
    }

    _getHeaderOffsetHeight() {
      let offset = 0;
      if (this._headerEl) offset += Math.round(this._headerEl.getBoundingClientRect().height || 0);
      if (this.classList.contains('is-sticky')) offset += Math.round(this.getBoundingClientRect().height || 0);
      return offset;
    }

    _updateStuckState() {
      if (!this._wrapper || !this.classList.contains('is-sticky')) return;
      const hh = this._headerEl ? this._headerEl.getBoundingClientRect().height : 0;
      const top = this._wrapper.getBoundingClientRect().top;
      if (top > hh + 1) {
        this._naturalTop = top + window.scrollY;
        this._wrapper.classList.remove('is-stuck');
        return;
      }
      const stuck = this._naturalTop != null ? window.scrollY + hh > this._naturalTop + 1 : window.scrollY > 1;
      this._wrapper.classList.toggle('is-stuck', stuck);
    }

    _setActive(item) {
      if (!item || this._activeItem === item) return;

      this.querySelectorAll('[data-ndev-category-navbar-item]').forEach((el) => {
        el.classList.remove('is-active');
        el.removeAttribute('aria-current');
      });

      item.classList.add('is-active');
      item.setAttribute('aria-current', item.getAttribute('data-item-type') === 'link' ? 'page' : 'true');
      this._activeItem = item;

      // 激活项滚动居中（仅在容器可横向滚动时）
      if (!this._container) return;
      if (this._container.scrollWidth <= this._container.clientWidth + 1) return;
      const r = item.getBoundingClientRect();
      const c = this._container.getBoundingClientRect();
      const center = r.left - c.left + r.width / 2;
      const left = Math.max(0, center - this._container.clientWidth / 2);
      const reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      this._container.scrollTo({ left, behavior: reduced ? 'auto' : 'smooth' });
    }

    _scrollToAnchorIndex(anchorIndex) {
      const idx = parseInt(anchorIndex, 10);
      if (!idx || idx < 1) return null;
      const target = this._sections.length ? this._sections[idx - 1] : null;
      if (!target || !target.getBoundingClientRect) return null;

      const offset = this._getHeaderOffsetHeight();
      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
      const reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });
      return { idx, target };
    }

    _computeMatchedAnchorIndex() {
      if (!this._sections.length) return null;

      const marker = this._getHeaderOffsetHeight() + 1;
      let globalIdx = 1;
      for (let i = this._sections.length - 1; i >= 0; i--) {
        const rect = this._sections[i].getBoundingClientRect();
        if (rect && rect.top <= marker) {
          globalIdx = i + 1;
          break;
        }
      }

      // 精确匹配
      if (this._anchorItemMap[globalIdx]) return globalIdx;

      // 找最近的小于等于当前 section index
      let matched = null;
      for (const key of this._anchorKeys) {
        if (key <= globalIdx) matched = key;
      }
      return matched;
    }

    _clearLock() {
      this._lock = null;
      if (this._lockIdleTimer) {
        clearTimeout(this._lockIdleTimer);
        this._lockIdleTimer = null;
      }
      if (this._lockMaxTimer) {
        clearTimeout(this._lockMaxTimer);
        this._lockMaxTimer = null;
      }
      if (this._unbindUserCancel) {
        this._unbindUserCancel();
        this._unbindUserCancel = null;
      }
    }

    _syncActiveByScroll() {
      if (this._lock) return;
      const matched = this._computeMatchedAnchorIndex();
      if (matched !== null && this._anchorItemMap[matched]) this._setActive(this._anchorItemMap[matched]);
    }

    _bindUserIntentCancel() {
      const onUserIntent = () => {
        if (this._lock) this._clearLock();
      };
      const onKeyDown = (ev) => {
        if (!this._lock) return;
        const k = ev && ev.key ? ev.key : '';
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar'].includes(k)) {
          this._clearLock();
        }
      };
      window.addEventListener('wheel', onUserIntent, { passive: true, capture: true });
      window.addEventListener('touchstart', onUserIntent, { passive: true, capture: true });
      window.addEventListener('pointerdown', onUserIntent, { passive: true, capture: true });
      window.addEventListener('keydown', onKeyDown, true);
      return () => {
        window.removeEventListener('wheel', onUserIntent, true);
        window.removeEventListener('touchstart', onUserIntent, true);
        window.removeEventListener('pointerdown', onUserIntent, true);
        window.removeEventListener('keydown', onKeyDown, true);
      };
    }

    _beginLock() {
      this._clearLock();
      this._lock = true;
      this._unbindUserCancel = this._bindUserIntentCancel();
      this._lockMaxTimer = setTimeout(() => {
        this._clearLock();
        this._syncActiveByScroll();
      }, NdevCategoryNavbar.LOCK_MAX_MS);
    }

    _armIdleUnlock() {
      if (this._lockIdleTimer) clearTimeout(this._lockIdleTimer);
      this._lockIdleTimer = setTimeout(() => {
        if (!this._lock) return;
        this._clearLock();
        this._syncActiveByScroll();
      }, NdevCategoryNavbar.LOCK_IDLE_MS);
    }

    _onScroll() {
      if (this._ticking) return;
      this._ticking = true;
      window.requestAnimationFrame(() => {
        this._ticking = false;
        this._updateStuckState();

        if (this._lock) {
          this._armIdleUnlock();
          return;
        }

        this._syncActiveByScroll();
      });
    }

    _onClickCapture(ev) {
      const target = ev && ev.target ? ev.target : null;
      if (!target || !target.closest) return;
      const item = target.closest('[data-ndev-category-navbar-item]');
      if (!item || !this.contains(item)) return;

      const type = item.getAttribute('data-item-type');
      if (type === 'link') return;

      if (type === 'anchor') {
        ev.preventDefault();
        this._setActive(item);
        const info = this._scrollToAnchorIndex(item.getAttribute('data-anchor-index'));
        if (info) this._beginLock();
      }
    }
  }

  if (!customElements.get('ndev-category-navbar')) {
    customElements.define('ndev-category-navbar', NdevCategoryNavbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-navbar"] && !Shopify.designMode) return;
  try {
    
  class NdevNavbar extends HTMLElement {
    static LOCK_IDLE_MS = 220; // 停止滚动多久后解锁
    static LOCK_MAX_MS = 6000; // 最大锁定时间兜底，避免极端情况锁死

    connectedCallback() {
      this._headerEl = document.querySelector('#site-header');
      this._sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section, #main-content .shopify-section'));
      this._listContainer = this.querySelector('.ndev-navbar__list');
      this._wrapper = this.closest('.ndev-navbar-section');
      this._activeItem = null;
      this._lock = null;
      this._naturalTop = null;
      this._ticking = false;

      const mainContent = document.querySelector('#MainContent, #main-content');
      if (mainContent && window.MutationObserver) {
        this._sectionsObserver = new MutationObserver(() => {
          this._sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section, #main-content .shopify-section'));
        });
        this._sectionsObserver.observe(mainContent, { childList: true });
      }

      // 收集所有滚动定位按钮，构建 section index → 按钮映射
      this._anchorItemMap = {};
      if (this._listContainer) {
        this._listContainer.querySelectorAll('[data-btn-purpose="scroll"]').forEach((el) => {
          const ai = parseInt(el.getAttribute('data-scroll-section-index') || '', 10);
          if (ai) this._anchorItemMap[ai] = el;
        });
      }
      this._anchorKeys = Object.keys(this._anchorItemMap)
        .map(Number)
        .sort((a, b) => a - b);

      // 默认激活第一个
      if (this._anchorKeys.length > 0) {
        this._setActive(this._anchorItemMap[this._anchorKeys[0]]);
      }

      this._onScroll = this._onScroll.bind(this);
      this._onClickCapture = this._onClickCapture.bind(this);

      this.addEventListener('click', this._onClickCapture, true);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });

      this._onScroll();
    }

    disconnectedCallback() {
      this._clearLock();
      this.removeEventListener('click', this._onClickCapture, true);
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      if (this._sectionsObserver) this._sectionsObserver.disconnect();
      if (this._wrapper) this._wrapper.classList.remove('is-stuck');
    }

    _getHeaderOffsetHeight() {
      let offset = 0;
      if (this._headerEl) offset += Math.round(this._headerEl.getBoundingClientRect().height || 0);
      if (this.classList.contains('is-sticky')) offset += Math.round(this.getBoundingClientRect().height || 0);
      return offset;
    }

    _updateStuckState() {
      if (!this._wrapper || !this.classList.contains('is-sticky')) return;
      const hh = this._headerEl ? this._headerEl.getBoundingClientRect().height : 0;
      const top = this._wrapper.getBoundingClientRect().top;
      if (top > hh + 1) {
        this._naturalTop = top + window.scrollY;
        this._wrapper.classList.remove('is-stuck');
        return;
      }
      const stuck = this._naturalTop != null ? window.scrollY + hh > this._naturalTop + 1 : window.scrollY > 1;
      this._wrapper.classList.toggle('is-stuck', stuck);
    }

    _setActive(item) {
      if (!item || !this._listContainer || this._activeItem === item) return;

      // 只更新导航列表中的按钮（不影响右侧区域）
      this._listContainer.querySelectorAll('.ndev-button .ndev-button__btn').forEach((el) => {
        el.classList.remove('is-active');
      });

      item.classList.add('is-active');
      this._activeItem = item;

      // 激活按钮滚动居中（PC 和移动端都适用）
      const btnWrapper = item.closest('.ndev-button');
      const r = (btnWrapper || item).getBoundingClientRect();
      const c = this._listContainer.getBoundingClientRect();
      const center = r.left - c.left + r.width / 2;
      const left = Math.max(0, center - this._listContainer.clientWidth / 2);
      const reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      this._listContainer.scrollTo({ left, behavior: reduced ? 'auto' : 'smooth' });
    }

    _computeMatchedAnchorIndex() {
      if (!this._sections.length) return null;

      const marker = this._getHeaderOffsetHeight() + 1;
      let globalIdx = 1;
      for (let i = this._sections.length - 1; i >= 0; i--) {
        const rect = this._sections[i].getBoundingClientRect();
        if (rect && rect.top <= marker) {
          globalIdx = i + 1;
          break;
        }
      }

      // 精确匹配
      if (this._anchorItemMap[globalIdx]) return globalIdx;

      // 找最近的小于等于当前 section index
      let matched = null;
      for (const key of this._anchorKeys) {
        if (key <= globalIdx) matched = key;
      }
      return matched;
    }

    _clearLock() {
      this._lock = null;
      if (this._lockIdleTimer) {
        clearTimeout(this._lockIdleTimer);
        this._lockIdleTimer = null;
      }
      if (this._lockMaxTimer) {
        clearTimeout(this._lockMaxTimer);
        this._lockMaxTimer = null;
      }
      if (this._unbindUserCancel) {
        this._unbindUserCancel();
        this._unbindUserCancel = null;
      }
    }

    _syncActiveByScroll() {
      if (this._lock) return;
      const matched = this._computeMatchedAnchorIndex();
      if (matched !== null && this._anchorItemMap[matched]) this._setActive(this._anchorItemMap[matched]);
    }

    _bindUserIntentCancel() {
      const onUserIntent = () => {
        if (this._lock) this._clearLock();
      };
      const onKeyDown = (ev) => {
        if (!this._lock) return;
        const k = ev && ev.key ? ev.key : '';
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar'].includes(k)) {
          this._clearLock();
        }
      };
      window.addEventListener('wheel', onUserIntent, { passive: true, capture: true });
      window.addEventListener('touchstart', onUserIntent, { passive: true, capture: true });
      window.addEventListener('pointerdown', onUserIntent, { passive: true, capture: true });
      window.addEventListener('keydown', onKeyDown, true);
      return () => {
        window.removeEventListener('wheel', onUserIntent, true);
        window.removeEventListener('touchstart', onUserIntent, true);
        window.removeEventListener('pointerdown', onUserIntent, true);
        window.removeEventListener('keydown', onKeyDown, true);
      };
    }

    _beginLock() {
      this._clearLock();
      this._lock = true;
      this._unbindUserCancel = this._bindUserIntentCancel();
      this._lockMaxTimer = setTimeout(() => {
        this._clearLock();
        this._syncActiveByScroll();
      }, NdevNavbar.LOCK_MAX_MS);
    }

    _armIdleUnlock() {
      if (this._lockIdleTimer) clearTimeout(this._lockIdleTimer);
      this._lockIdleTimer = setTimeout(() => {
        if (!this._lock) return;
        this._clearLock();
        this._syncActiveByScroll();
      }, NdevNavbar.LOCK_IDLE_MS);
    }

    _onScroll() {
      if (this._ticking) return;
      this._ticking = true;
      window.requestAnimationFrame(() => {
        this._ticking = false;
        this._updateStuckState();

        if (this._lock) {
          this._armIdleUnlock();
          return;
        }

        this._syncActiveByScroll();
      });
    }

    // 监听按钮点击（capture 阶段），设置锁定，防止滚动回显覆盖
    _onClickCapture(ev) {
      const target = ev && ev.target ? ev.target : null;
      if (!target || !target.closest) return;
      const btn = target.closest('[data-btn-purpose="scroll"]');
      if (!btn || !this.contains(btn)) return;

      this._setActive(btn);
      this._beginLock();
    }
  }

  if (!customElements.get('ndev-navbar')) {
    customElements.define('ndev-navbar', NdevNavbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-product-compare-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-product-compare-table';
    const ROOT_SELECTOR = '[data-ndev-product-compare-table]';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    const raf2 = (fn) => {
      if (typeof window.requestAnimationFrame !== 'function') {
        window.setTimeout(fn, 0);
        return;
      }
      window.requestAnimationFrame(() => window.requestAnimationFrame(fn));
    };

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    function isSwiperAvailable() {
      return typeof window.Swiper !== 'undefined';
    }

    function getGroupSize(swiper) {
      const size = parseInt(swiper?.params?.slidesPerGroup || '1', 10);
      return Number.isFinite(size) && size > 0 ? size : 1;
    }

    function getPageCount(total, groupSize) {
      if (!total || total < 1) return 1;
      const gs = groupSize > 0 ? groupSize : 1;
      return Math.max(1, Math.ceil(total / gs));
    }

    function getMaxStart(total, groupSize) {
      const gs = groupSize > 0 ? groupSize : 1;
      return Math.max(0, (total || 0) - gs);
    }

    function startForPage(pageIndex, total, groupSize) {
      const pageCount = getPageCount(total, groupSize);
      const maxStart = getMaxStart(total, groupSize);
      const idx = clamp(pageIndex || 0, 0, pageCount - 1);
      if (idx >= pageCount - 1) return maxStart;
      return clamp(idx * groupSize, 0, maxStart);
    }

    function pageForStart(start, total, groupSize) {
      const pageCount = getPageCount(total, groupSize);
      const maxStart = getMaxStart(total, groupSize);
      if (start >= maxStart) return pageCount - 1;
      return Math.floor(start / groupSize);
    }

    function buildPagination(paginationEl, pageCount) {
      if (!paginationEl) return;
      paginationEl.innerHTML = '';
      if (!pageCount || pageCount < 2) return;
      for (let i = 0; i < pageCount; i++) {
        const seg = document.createElement('span');
        seg.className = 'ndev-pctable__page-seg';
        seg.setAttribute('data-page-index', String(i));
        seg.setAttribute('role', 'button');
        seg.setAttribute('tabindex', '0');
        seg.setAttribute('aria-label', 'Go to page ' + String(i + 1));
        paginationEl.appendChild(seg);
      }
    }

    function setActivePagination(paginationEl, activeIndex) {
      if (!paginationEl) return;
      const segs = paginationEl.querySelectorAll('[data-page-index]');
      segs.forEach((seg) => {
        const isActive = seg.getAttribute('data-page-index') === String(activeIndex);
        seg.classList.toggle('is-active', isActive);
      });
    }

    function ensureRowCells(root, totalProducts) {
      if (!root || !totalProducts || totalProducts < 1) return;
      const blankAsCross = root.closest(ROOT_SELECTOR)?.getAttribute('data-blank-as-cross') === '1';

      root.querySelectorAll('[data-ndev-pctable-row]').forEach((row) => {
        const cells = Array.from(row.querySelectorAll('[data-ndev-pctable-cell]'));
        const missing = totalProducts - cells.length;
        if (missing > 0) {
          for (let i = 0; i < missing; i++) {
            const cell = document.createElement('div');
            cell.className = 'ndev-product-compare-table__cell ndev-product-compare-table__cell--blank';
            cell.setAttribute('data-ndev-pctable-cell', '1');
            cell.setAttribute('data-cell-type', blankAsCross ? 'cross' : 'blank');
            cell.innerHTML = blankAsCross ? '<span class="ndev-product-compare-table__icon is-cross" aria-hidden="true"></span>' : '';
            row.appendChild(cell);
          }
        }

        const finalCells = Array.from(row.querySelectorAll('[data-ndev-pctable-cell]'));
        finalCells.forEach((cell, idx) => cell.setAttribute('data-col-index', String(idx)));
      });
    }

    function syncVisibleColumns(root, visibleIndexes, visibleCount) {
      if (!root) return;
      const set = new Set(visibleIndexes.map((n) => String(n)));

      root.style.setProperty('--ndev-pctable-visible-cols', String(visibleCount));
      root.style.setProperty('--ndev-pctable-cols', String((visibleCount || 0) + 1));

      root.querySelectorAll('[data-ndev-pctable-row]').forEach((row) => {
        row.querySelectorAll('[data-ndev-pctable-cell]').forEach((cell) => {
          const idx = cell.getAttribute('data-col-index');
          const show = idx != null && set.has(String(idx));
          cell.classList.toggle('is-hidden', !show);
        });
      });

      if (!root.classList.contains('is-ready')) root.classList.add('is-ready');
    }

    function initCompareRoot(sectionRoot, compareRoot) {
      const swiperEl = compareRoot.querySelector('[data-ndev-pctable-swiper]');
      const paginationEl = compareRoot.querySelector('[data-ndev-pctable-pagination]');
      if (!swiperEl) return null;
      const slidesStatic = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
      const totalStatic = slidesStatic.length;

      const getStaticVisibleCount = () => (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches ? 3 : 2);

      // Swiper 不存在时：降级为“静态首屏列展示”，避免表格网格错乱
      if (!isSwiperAvailable()) {
        ensureRowCells(compareRoot, totalStatic);

        const apply = () => {
          const visibleCount = Math.min(getStaticVisibleCount(), totalStatic || getStaticVisibleCount());
          const visible = [];
          for (let i = 0; i < visibleCount; i++) visible.push(i);
          const pageCount = visibleCount > 0 ? Math.ceil((totalStatic || 0) / visibleCount) : 1;
          buildPagination(paginationEl, pageCount);
          setActivePagination(paginationEl, 0);
          syncVisibleColumns(compareRoot, visible, visible.length);
        };

        apply();

        const onResize = () => apply();
        window.addEventListener('resize', onResize);

        return {
          destroy: () => {
            try {
              window.removeEventListener('resize', onResize);
            } catch (e) {}
          },
        };
      }

      const readGap = () => {
        try {
          const v = window.getComputedStyle(compareRoot).getPropertyValue('--ndev-pctable-gap').trim();
          const n = parseFloat(v);
          return Number.isFinite(n) && n > 0 ? n : 20;
        } catch (e) {
          return 20;
        }
      };

      const gap = readGap();

      // 注意：Swiper 的 init 回调可能在构造时同步触发，
      // 因此所有会在回调里访问的变量必须在 new Swiper() 之前完成初始化（避免 TDZ）。
      let isSyncing = false;

      function syncFromSwiper(sw) {
        if (!sw || isSyncing) return;
        isSyncing = true;

        try {
          const total = sw.slides ? sw.slides.length : 0;
          const perViewRaw = sw?.params?.slidesPerView;
          const perView = parseInt(String(perViewRaw || '1'), 10) || 1;
          const maxStart = Math.max(0, total - perView);
          const start = clamp(sw.activeIndex || 0, 0, maxStart);

          ensureRowCells(compareRoot, total);

          const visible = [];
          for (let i = 0; i < perView; i++) {
            const v = start + i;
            if (v < total) visible.push(v);
          }
          syncVisibleColumns(compareRoot, visible, visible.length);
        } finally {
          isSyncing = false;
        }
      }

      paginationEl.setAttribute('data-page-count', String(totalStatic));

      const swiper = new window.Swiper(swiperEl, {
        slidesPerView: 2,
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        spaceBetween: gap,
        speed: 300,
        watchOverflow: true,
        resistanceRatio: 0.85,
        freeMode: false,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
              bulletClass: 'ndev-pctable__page-seg',
              bulletActiveClass: 'is-active',
              renderBullet: function (index, className) {
                return `<span class="${className}" role="button" tabindex="0" aria-label="Go to page ${index + 1}"></span>`;
              },
            }
          : undefined,
        breakpoints: {
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: gap,
          },
        },
        on: {
          init: function () {
            syncFromSwiper(this);
          },
          slideChangeTransitionEnd: function () {
            syncFromSwiper(this);
          },
          transitionEnd: function () {
            syncFromSwiper(this);
          },
          breakpoint: function () {
            syncFromSwiper(this);
          },
          resize: function () {
            syncFromSwiper(this);
          },
        },
      });

      // 首次强制同步（避免 swiper init 前后闪动）
      raf2(() => {
        try {
          swiper.update();
          syncFromSwiper(swiper);
        } catch (e) {}
      });

      return {
        destroy: () => {
          try {
            swiper?.destroy?.(true, true);
          } catch (e) {}
        },
      };
    }

    function destroyOne(sectionRoot) {
      const controller = sectionRoot ? controllers.get(sectionRoot) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (sectionRoot) controllers.delete(sectionRoot);
    }

    function initOne(sectionRoot) {
      if (!sectionRoot) return;
      destroyOne(sectionRoot);

      const compareRoots = Array.from(sectionRoot.querySelectorAll('[data-ndev-pctable-root]'));
      const cleanups = [];

      compareRoots.forEach((compareRoot) => {
        const inst = initCompareRoot(sectionRoot, compareRoot);
        if (!inst) return;
        cleanups.push(() => {
          try {
            inst.destroy?.();
          } catch (e) {}
        });
      });

      controllers.set(sectionRoot, {
        destroy: () => {
          cleanups.forEach((fn) => {
            try {
              fn();
            } catch (e) {}
          });
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event?.target || null));
    document.addEventListener('shopify:section:unload', (event) => destroyAll(event?.target || null));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-product-compare-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-product-compare-tabs';
    const ROOT_SELECTOR = '[data-ndev-product-compare-tabs]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const compareRoots = Array.prototype.slice.call(root.querySelectorAll('[data-ndev-pct-tabs-root]'));
      const cleanups = [];

      function initCompare(compareRoot) {
        const tabWrap = compareRoot.querySelector('.ndev-pct__tabs');
        const track = compareRoot.querySelector('.ndev-pct__indicator-track');
        const indicator = compareRoot.querySelector('[data-ndev-pct-indicator]');
        const panelsWrap = compareRoot.querySelector('[data-ndev-pct-panels]');
        if (!tabWrap || !track || !indicator || !panelsWrap) return;

        const panels = Array.prototype.slice.call(panelsWrap.querySelectorAll('[data-ndev-pct-panel]'));
        const tabs = [];
        const blankAsCross = root.getAttribute('data-blank-as-cross') === '1';

        // 从每个 panel 内提取 tab button，塞入 tablist
        for (var i = 0; i < panels.length; i++) {
          const panel = panels[i];
          const btn = panel.querySelector('[data-ndev-pct-tab-btn]');
          if (!btn) continue;
          tabWrap.appendChild(btn);
          tabs.push(btn);
        }

        function ensureRowCells(panel, cols) {
          if (!cols || cols < 1) return;
          const rows = panel.querySelectorAll('[data-ndev-pct-row]');
          for (var r = 0; r < rows.length; r++) {
            const row = rows[r];
            const cells = row.querySelectorAll('.ndev-pct__cell');
            const missing = cols - cells.length;
            if (missing <= 0) continue;
            for (var m = 0; m < missing; m++) {
              const cell = document.createElement('div');
              cell.className = 'ndev-pct__cell';
              cell.setAttribute('data-ndev-pct-cell', '1');
              cell.textContent = blankAsCross ? '×' : '';
              row.appendChild(cell);
            }
          }
        }

        // 标号 + a11y + cols
        for (var j = 0; j < tabs.length; j++) {
          const idx = String(j + 1);
          const blockId = compareRoot.getAttribute('data-block-id') || 'root';
          const tabId = 'ndev-pct-tab-' + root.getAttribute('data-section-id') + '-' + blockId + '-' + idx;
          const panelId = 'ndev-pct-panel-' + root.getAttribute('data-section-id') + '-' + blockId + '-' + idx;

          tabs[j].setAttribute('data-ndev-pct-tab', idx);
          tabs[j].setAttribute('role', 'tab');
          tabs[j].setAttribute('id', tabId);
          tabs[j].setAttribute('aria-controls', panelId);

          panels[j].setAttribute('data-ndev-pct-panel', idx);
          panels[j].setAttribute('role', 'tabpanel');
          panels[j].setAttribute('id', panelId);
          panels[j].setAttribute('aria-labelledby', tabId);

          var productCount = panels[j].querySelectorAll('[data-ndev-pct-product]').length;
          if (!productCount || productCount < 1) productCount = 1;

          var mbMinCols = parseInt(root.getAttribute('data-mb-min-cols') || '1', 10);
          var mbCols = Math.max(productCount, mbMinCols);

          panels[j].style.setProperty('--pct-cols', String(productCount));
          panels[j].style.setProperty('--pct-mb-cols', String(mbCols));
          panels[j].setAttribute('data-cols', String(productCount));
          ensureRowCells(panels[j], productCount);
        }

        function setIndicatorTo(btn) {
          if (!btn) return;
          const trackRect = track.getBoundingClientRect();
          const btnRect = btn.getBoundingClientRect();
          const left = btnRect.left - trackRect.left;
          indicator.style.width = btnRect.width + 'px';
          indicator.style.transform = 'translateX(' + left + 'px)';
        }

        function setActive(indexStr) {
          const index = String(indexStr);
          for (var k = 0; k < tabs.length; k++) {
            const isActive = tabs[k].getAttribute('data-ndev-pct-tab') === index;
            tabs[k].classList.toggle('is-active', isActive);
            tabs[k].setAttribute('aria-selected', isActive ? 'true' : 'false');
            if (isActive) setIndicatorTo(tabs[k]);
          }
          for (var m = 0; m < panels.length; m++) {
            const isActivePanel = panels[m].getAttribute('data-ndev-pct-panel') === index;
            panels[m].classList.toggle('is-active', isActivePanel);
          }
        }

        function onClick(e) {
          const btn = e.target && e.target.closest ? e.target.closest('[data-ndev-pct-tab]') : null;
          if (!btn || !compareRoot.contains(btn)) return;
          e.preventDefault();
          setActive(btn.getAttribute('data-ndev-pct-tab'));
        }

        function onResize() {
          const active = compareRoot.querySelector('[data-ndev-pct-tab].is-active') || tabs[0];
          if (active) setIndicatorTo(active);
        }

        if (tabs.length) {
          compareRoot.addEventListener('click', onClick);
          window.addEventListener('resize', onResize);
          cleanups.push(function () {
            try { compareRoot.removeEventListener('click', onClick); } catch (e) {}
            try { window.removeEventListener('resize', onResize); } catch (e) {}
          });

          const defaultTab = root.getAttribute('data-default-tab') || '1';
          setActive(defaultTab);
          onResize();
        }
      }

      for (var r = 0; r < compareRoots.length; r++) initCompare(compareRoots[r]);

      controllers.set(root, {
        root: root,
        destroy: function () {
          // 清理事件监听器、定时器等（注意移除你在 init 里绑定的监听）
          for (var i = 0; i < cleanups.length; i++) {
            try { cleanups[i](); } catch (e) {}
          }
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-site-header"] && !Shopify.designMode) return;
  try {
    
  class NdevSiteHeader extends BaseElement {
    init() {
      this.dispose();
      this._rafId = null;
      this._drawerFocusRafId = null;
      this._cartLinkFocusRafId = null;
      this._searchFocusRafId = null;
      this._navFocusRafId = null;
      this._navResizeRafId = null;
      this._searchDebounceId = null;
      this._searchAbortController = null;
      this._searchRequestSequence = 0;
      this._cartLink = this.querySelector('.header-cart-link');
      this._cartDrawer = document.getElementById('header-cart');
      this._searchTrigger = this.querySelector('.ndev-site-header__search-trigger');
      this._searchPanel = this.querySelector('.ndev-site-header__search-panel');
      this._searchOverlay = this.querySelector('.ndev-site-header__search-overlay');
      this._searchClose = this.querySelector('.ndev-site-header__search-close');
      this._searchForm = this.querySelector('.ndev-site-header__search-form');
      this._searchInput = this.querySelector('.ndev-site-header__search-input');
      this._searchClear = this.querySelector('.ndev-site-header__search-clear');
      this._searchSuggestions = this.querySelector('.ndev-site-header__suggestions');
      this._searchResults = this.querySelector('.ndev-site-header__suggestion-list');
      this._searchStatus = this.querySelector('.ndev-site-header__search-status');
      this._navList = this.querySelector('.site-header-nav-list');
      this._navTrigger = this.querySelector('.ndev-site-header__menu-trigger');
      this._countrySelectorTrigger = this.querySelector('.site-header-nav-list__country-trigger');
      this._navOverlay = this._navList?.querySelector('.site-header-nav-list__overlay');
      this._navGroups = this._navList ? Array.from(this._navList.querySelectorAll('.site-header-nav-grouped-link__details')) : [];
      this._navGroupItems = this._navGroups
        .map((details) => details.closest('.site-header-nav-grouped-link'))
        .filter(Boolean);
      this._navMediaQuery = window.matchMedia('(min-width: 1024px)');
      const searchLabel = this._searchPanel?.getAttribute('search-label');
      const searchCloseLabel = this._searchPanel?.getAttribute('search-close-label');
      if (searchLabel) {
        this._searchTrigger?.setAttribute('aria-label', searchLabel);
        this._searchTrigger?.setAttribute('title', searchLabel);
      }
      if (searchCloseLabel) this._searchClose?.setAttribute('aria-label', searchCloseLabel);
      const navOpenLabel = this._navList?.getAttribute('open-label');
      const navCloseLabel = this._navList?.getAttribute('close-label');
      if (navOpenLabel) {
        this._navTrigger?.setAttribute('aria-label', navOpenLabel);
        this._navTrigger?.setAttribute('data-open-label', navOpenLabel);
      }
      if (navCloseLabel) this._navTrigger?.setAttribute('data-close-label', navCloseLabel);
      this._drawerWasOpen = this._isDrawerOpen();
      this._navWasOpen = false;
      this._shouldFocusDrawer = false;
      this._suppressCartFocusRestore = false;
      this._lastSearchTrigger = null;
      this._lastNavTrigger = null;
      this._activeSuggestionIndex = -1;
      this._onScroll = this._handleScroll.bind(this);
      this._onCartClick = this._handleCartClick.bind(this);
      this._onDocumentKeydown = this._handleDocumentKeydown.bind(this);
      this._onSearchTriggerClick = this._handleSearchTriggerClick.bind(this);
      this._onSearchOverlayClick = this._handleSearchOverlayClick.bind(this);
      this._onSearchCloseClick = this._handleSearchCloseClick.bind(this);
      this._onSearchInput = this._handleSearchInput.bind(this);
      this._onSearchClearClick = this._handleSearchClearClick.bind(this);
      this._onNavTriggerClick = this._handleNavTriggerClick.bind(this);
      this._onCountrySelectorClick = this._handleCountrySelectorClick.bind(this);
      this._onNavOverlayClick = this._handleNavOverlayClick.bind(this);
      this._onNavClick = this._handleNavClick.bind(this);
      this._onNavToggle = this._handleNavToggle.bind(this);
      this._onNavPointerOver = this._handleNavPointerOver.bind(this);
      this._onNavPointerOut = this._handleNavPointerOut.bind(this);
      this._onNavFocusIn = this._handleNavFocusIn.bind(this);
      this._onNavFocusOut = this._handleNavFocusOut.bind(this);
      this._onNavMediaChange = this._syncNavViewport.bind(this);
      this._onNavResize = this._handleNavResize.bind(this);
      this._onThemeBlockSelect = this._handleThemeBlockSelect.bind(this);
      this._onThemeBlockDeselect = this._handleThemeBlockDeselect.bind(this);
      this._onDocumentClick = this._handleDocumentClick.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this._cartLink?.addEventListener('click', this._onCartClick);
      this._searchTrigger?.addEventListener('click', this._onSearchTriggerClick);
      this._searchOverlay?.addEventListener('click', this._onSearchOverlayClick);
      this._searchClose?.addEventListener('click', this._onSearchCloseClick);
      this._searchInput?.addEventListener('input', this._onSearchInput);
      this._searchClear?.addEventListener('click', this._onSearchClearClick);
      this._navTrigger?.addEventListener('click', this._onNavTriggerClick);
      this._countrySelectorTrigger?.addEventListener('click', this._onCountrySelectorClick, true);
      this._navOverlay?.addEventListener('click', this._onNavOverlayClick);
      this._navList?.addEventListener('click', this._onNavClick);
      this._navList?.addEventListener('toggle', this._onNavToggle, true);
      this._navGroupItems.forEach((item) => {
        item.addEventListener('pointerenter', this._onNavPointerOver);
        item.addEventListener('pointerleave', this._onNavPointerOut);
      });
      this._navList?.addEventListener('focusin', this._onNavFocusIn);
      this._navList?.addEventListener('focusout', this._onNavFocusOut);
      this._navMediaQuery.addEventListener('change', this._onNavMediaChange);
      window.addEventListener('resize', this._onNavResize, { passive: true });
      this.addEventListener('shopify:block:select', this._onThemeBlockSelect);
      this.addEventListener('shopify:block:deselect', this._onThemeBlockDeselect);
      document.addEventListener('keydown', this._onDocumentKeydown);
      document.addEventListener('click', this._onDocumentClick);

      if (this._cartDrawer) {
        this._drawerObserver = new MutationObserver(() => this._syncDrawerState());
        this._drawerObserver.observe(this._cartDrawer, {
          attributes: true,
          attributeFilter: ['class'],
          childList: true,
        });
      }

      this._syncScrollState();
      if (this._navList) {
        this._navGroups.forEach((details) => {
          details.open = false;
        });
        this._syncNavViewport();
      }
      this._syncDrawerState();
    }

    dispose() {
      if (this._onScroll) {
        window.removeEventListener('scroll', this._onScroll);
      }
      if (this._cartLink && this._onCartClick) {
        this._cartLink.removeEventListener('click', this._onCartClick);
      }
      if (this._searchTrigger && this._onSearchTriggerClick) {
        this._searchTrigger.removeEventListener('click', this._onSearchTriggerClick);
      }
      if (this._searchOverlay && this._onSearchOverlayClick) {
        this._searchOverlay.removeEventListener('click', this._onSearchOverlayClick);
      }
      if (this._searchClose && this._onSearchCloseClick) {
        this._searchClose.removeEventListener('click', this._onSearchCloseClick);
      }
      if (this._searchInput && this._onSearchInput) {
        this._searchInput.removeEventListener('input', this._onSearchInput);
      }
      if (this._searchClear && this._onSearchClearClick) {
        this._searchClear.removeEventListener('click', this._onSearchClearClick);
      }
      this._navTrigger?.removeEventListener('click', this._onNavTriggerClick);
      this._countrySelectorTrigger?.removeEventListener('click', this._onCountrySelectorClick, true);
      this._navOverlay?.removeEventListener('click', this._onNavOverlayClick);
      this._navList?.removeEventListener('click', this._onNavClick);
      this._navList?.removeEventListener('toggle', this._onNavToggle, true);
      this._navGroupItems?.forEach((item) => {
        item.removeEventListener('pointerenter', this._onNavPointerOver);
        item.removeEventListener('pointerleave', this._onNavPointerOut);
      });
      this._navList?.removeEventListener('focusin', this._onNavFocusIn);
      this._navList?.removeEventListener('focusout', this._onNavFocusOut);
      this._navMediaQuery?.removeEventListener('change', this._onNavMediaChange);
      if (this._onNavResize) {
        window.removeEventListener('resize', this._onNavResize);
      }
      if (this._onThemeBlockSelect) {
        this.removeEventListener('shopify:block:select', this._onThemeBlockSelect);
      }
      if (this._onThemeBlockDeselect) {
        this.removeEventListener('shopify:block:deselect', this._onThemeBlockDeselect);
      }
      if (this._onDocumentKeydown) {
        document.removeEventListener('keydown', this._onDocumentKeydown);
      }
      if (this._onDocumentClick) {
        document.removeEventListener('click', this._onDocumentClick);
      }
      this._drawerObserver?.disconnect();
      if (this._rafId !== null && this._rafId !== undefined) {
        window.cancelAnimationFrame(this._rafId);
      }
      if (this._drawerFocusRafId !== null && this._drawerFocusRafId !== undefined) {
        window.cancelAnimationFrame(this._drawerFocusRafId);
      }
      if (this._cartLinkFocusRafId !== null && this._cartLinkFocusRafId !== undefined) {
        window.cancelAnimationFrame(this._cartLinkFocusRafId);
      }
      if (this._searchFocusRafId !== null && this._searchFocusRafId !== undefined) {
        window.cancelAnimationFrame(this._searchFocusRafId);
      }
      if (this._navFocusRafId !== null && this._navFocusRafId !== undefined) {
        window.cancelAnimationFrame(this._navFocusRafId);
      }
      if (this._navResizeRafId !== null && this._navResizeRafId !== undefined) {
        window.cancelAnimationFrame(this._navResizeRafId);
      }
      if (this._searchDebounceId !== null && this._searchDebounceId !== undefined) {
        window.clearTimeout(this._searchDebounceId);
      }
      this._searchAbortController?.abort();
      this._closeNav({ restoreFocus: false });
      this._syncNavLayerState({ forceInactive: true });
      this.classList.remove('is-theme-editor-nav-active');
      this._navList?.style.removeProperty('--site-header-nav-panel-top');
      this._searchPanel?.setAttribute('inert', '');
      this._searchPanel?.setAttribute('aria-hidden', 'true');
      if (this._searchPanel) this._searchPanel.hidden = true;
      if (this._searchOverlay) this._searchOverlay.hidden = true;
      if (this._searchClose) this._searchClose.hidden = true;
      this._searchTrigger?.setAttribute('aria-expanded', 'false');
      this.closest('.site-header-section')?.classList.remove('is-search-open');
      this.classList.remove('is-search-open');
      this.classList.remove('is-nav-open');
      document.body.classList.remove('ndev-site-search-open');
      document.body.classList.remove('ndev-site-nav-open');
      this.classList.remove('is-scrolled');
      this._rafId = null;
      this._drawerFocusRafId = null;
      this._cartLinkFocusRafId = null;
      this._searchFocusRafId = null;
      this._navFocusRafId = null;
      this._navResizeRafId = null;
      this._searchDebounceId = null;
      this._searchAbortController = null;
      this._searchRequestSequence += 1;
      this._cartLink = null;
      this._cartDrawer = null;
      this._searchTrigger = null;
      this._searchPanel = null;
      this._searchOverlay = null;
      this._searchClose = null;
      this._searchForm = null;
      this._searchInput = null;
      this._searchClear = null;
      this._searchSuggestions = null;
      this._searchResults = null;
      this._searchStatus = null;
      this._navList = null;
      this._navTrigger = null;
      this._countrySelectorTrigger = null;
      this._navOverlay = null;
      this._navGroups = null;
      this._navGroupItems = null;
      this._navMediaQuery = null;
      this._drawerObserver = null;
      this._drawerWasOpen = false;
      this._navWasOpen = false;
      this._shouldFocusDrawer = false;
      this._lastNavTrigger = null;
      this._selectedThemeNavBlock = null;
      this._onScroll = null;
      this._onCartClick = null;
      this._onDocumentKeydown = null;
      this._onSearchTriggerClick = null;
      this._onSearchOverlayClick = null;
      this._onSearchCloseClick = null;
      this._onSearchInput = null;
      this._onSearchClearClick = null;
      this._onNavTriggerClick = null;
      this._onCountrySelectorClick = null;
      this._onNavOverlayClick = null;
      this._onNavClick = null;
      this._onNavToggle = null;
      this._onNavPointerOver = null;
      this._onNavPointerOut = null;
      this._onNavFocusIn = null;
      this._onNavFocusOut = null;
      this._onNavMediaChange = null;
      this._onNavResize = null;
      this._onThemeBlockSelect = null;
      this._onThemeBlockDeselect = null;
      this._onDocumentClick = null;
    }

    _handleThemeBlockSelect(event) {
      const target = event.target;
      if (!(target instanceof Element) || !this._navList?.contains(target)) return;

      this.classList.add('is-theme-editor-nav-active');
      this._selectedThemeNavBlock = target;

      const group = target.closest('.site-header-nav-grouped-link');
      const details = group?.querySelector(':scope > .site-header-nav-grouped-link__details');
      if (!details || !this._navGroups?.includes(details)) return;

      details.open = true;
      if (this._navMediaQuery?.matches) this._closeNavGroups({ except: details });
      this._syncNavPanelState();
    }

    _handleThemeBlockDeselect(event) {
      const target = event.target;
      if (!(target instanceof Element) || !this._navList?.contains(target)) return;
      if (target !== this._selectedThemeNavBlock) return;

      this._selectedThemeNavBlock = null;
      this.classList.remove('is-theme-editor-nav-active');
    }

    _handleNavTriggerClick(event) {
      if (!this._navList || this._navMediaQuery?.matches) return;

      event.preventDefault();
      this._setNavOpen(!this._isNavOpen(), { trigger: event.currentTarget });
    }

    _handleCountrySelectorClick() {
      if (this._isNavOpen()) this._closeNav({ restoreFocus: false });
    }

    _handleNavOverlayClick() {
      this._closeNavGroups();
    }

    _handleNavClick(event) {
      if (!this._navList) return;

      const summary = event.target.closest('.site-header-nav-grouped-link__summary');
      if (summary && this._navList.contains(summary)) {
        window.requestAnimationFrame(() => this._syncNavPanelState());
        return;
      }

      const link = event.target.closest('a[href]');
      if (link && this._navList.contains(link) && !this._navMediaQuery?.matches) {
        this._closeNav({ restoreFocus: false });
      }
    }

    _handleNavToggle(event) {
      const details = event.target;
      if (!details?.matches?.('.site-header-nav-grouped-link__details')) return;

      if (details.open) this._closeNavGroups({ except: details });
      this._syncNavPanelState();
    }

    _handleNavPointerOver(event) {
      if (!this._navMediaQuery?.matches) return;

      const group = event.currentTarget;
      const details = group?.querySelector(':scope > .site-header-nav-grouped-link__details');
      if (!details || !this._navGroups?.includes(details)) return;

      details.open = true;
      this._closeNavGroups({ except: details });
      this._syncNavPanelState();
    }

    _handleNavPointerOut(event) {
      if (!this._navMediaQuery?.matches) return;

      const group = event.currentTarget;
      const details = group?.querySelector(':scope > .site-header-nav-grouped-link__details');
      if (!details || !this._navGroups?.includes(details)) return;
      if (event.relatedTarget && group.contains(event.relatedTarget)) return;
      if (group.contains(document.activeElement)) return;

      details.open = false;
      this._syncNavPanelState();
    }

    _handleNavFocusIn(event) {
      if (!this._navMediaQuery?.matches) return;

      const link = event.target.closest('.site-header-nav-item--link > a.site-header-nav-item__action');
      if (link && this._navList?.contains(link)) return;

      const group = event.target.closest('.site-header-nav-grouped-link');
      const details = group?.querySelector(':scope > .site-header-nav-grouped-link__details');
      if (!details || !this._navList?.contains(details)) return;

      details.open = true;
      this._closeNavGroups({ except: details });
      this._syncNavPanelState();
    }

    _handleNavFocusOut(event) {
      if (!this._navMediaQuery?.matches) return;

      const link = event.target.closest('.site-header-nav-item--link > a.site-header-nav-item__action');
      if (link && this._navList?.contains(link)) return;

      const group = event.target.closest('.site-header-nav-grouped-link');
      const details = group?.querySelector(':scope > .site-header-nav-grouped-link__details');
      if (!details || !this._navList?.contains(details)) return;
      if (event.relatedTarget && group.contains(event.relatedTarget)) return;

      details.open = false;
      this._syncNavPanelState();
    }

    _handleDocumentClick(event) {
      if (!this._navMediaQuery?.matches || !this._hasOpenNavPanel()) return;
      if (this._navList?.contains(event.target) || this._navTrigger?.contains(event.target)) return;

      this._closeNavGroups();
    }

    _syncNavViewport() {
      if (!this._navList || !this._navMediaQuery) return;

      if (this._navMediaQuery.matches) {
        this._closeNavGroups();
        this._closeNav({ restoreFocus: false });
      } else {
        this._closeNavGroups();
      }
      this._syncNavPanelState();
    }

    _handleNavResize() {
      if (this._navResizeRafId !== null && this._navResizeRafId !== undefined) return;

      this._navResizeRafId = window.requestAnimationFrame(() => {
        this._navResizeRafId = null;
        this._syncNavPanelGeometry();
      });
    }

    _setNavOpen(isOpen, { trigger = this._navTrigger, restoreFocus = true } = {}) {
      if (!this._navList || !this._navTrigger) return;

      const wasOpen = this._isNavOpen();
      if (isOpen === wasOpen) {
        this._syncNavLayerState();
        return;
      }

      if (isOpen) {
        if (this._isSearchOpen()) this._closeSearch({ restoreFocus: false });
        if (this._isDrawerOpen() && typeof $360 !== 'undefined' && typeof $360.hideHeaderCart === 'function') {
          this._suppressCartFocusRestore = true;
          $360.hideHeaderCart();
        }

        this._lastNavTrigger = trigger;
        this.classList.add('is-nav-open');
        document.body.classList.add('ndev-site-nav-open');
        this._navTrigger.setAttribute('aria-expanded', 'true');
        const closeLabel = this._navTrigger.getAttribute('data-close-label');
        if (closeLabel) this._navTrigger.setAttribute('aria-label', closeLabel);
        this._scheduleNavFocus();
      } else {
        this.classList.remove('is-nav-open');
        document.body.classList.remove('ndev-site-nav-open');
        this._navTrigger.setAttribute('aria-expanded', 'false');
        const openLabel = this._navTrigger.getAttribute('data-open-label');
        if (openLabel) this._navTrigger.setAttribute('aria-label', openLabel);
        this._closeNavGroups();
        if (restoreFocus && wasOpen) this._lastNavTrigger?.focus();
        this._lastNavTrigger = null;
      }

      this._navWasOpen = isOpen;
      this._syncNavLayerState();
    }

    _closeNav({ restoreFocus = true } = {}) {
      this._setNavOpen(false, { restoreFocus });
    }

    _closeNavGroups({ except = null } = {}) {
      this._navGroups?.forEach((details) => {
        if (details !== except) details.open = false;
      });
      this._syncNavPanelState();
    }

    _syncNavPanelState() {
      const hasOpenPanel = Boolean(this._navMediaQuery?.matches && this._hasOpenNavPanel());
      this._syncNavPanelGeometry();
      if (this._navOverlay) this._navOverlay.hidden = !hasOpenPanel;
      this._syncNavLayerState();
    }

    _syncNavLayerState({ forceInactive = false } = {}) {
      const isDesktop = Boolean(this._navMediaQuery?.matches);
      const isActive = !forceInactive && (isDesktop ? this._hasOpenNavPanel() : this._isNavOpen());
      this.closest('.site-header-section')?.classList.toggle('is-nav-layer-active', isActive);
    }

    _syncNavPanelGeometry() {
      if (!this._navList || !this._navMediaQuery?.matches) return;

      const panelTop = Math.max(0, this.getBoundingClientRect().bottom);
      this._navList.style.setProperty('--site-header-nav-panel-top', `${panelTop}px`);
    }

    _scheduleNavFocus() {
      if (this._navFocusRafId !== null && this._navFocusRafId !== undefined) return;

      this._navFocusRafId = window.requestAnimationFrame(() => {
        this._navFocusRafId = null;
        if (!this._isNavOpen()) return;

        this._getNavFocusableElements().find((element) => element !== this._navTrigger)?.focus();
      });
    }

    _trapNavFocus(event) {
      const focusableElements = this._getNavFocusableElements();
      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      if (!focusableElements.includes(activeElement)) {
        event.preventDefault();
        (event.shiftKey ? lastElement : firstElement).focus();
      } else if (event.shiftKey && activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    _getNavFocusableElements() {
      if (!this._navList || !this._navTrigger) return [];

      const navElements = Array.from(this._navList.querySelectorAll(
        'summary, a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((element) => element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true');

      return [this._navTrigger, ...navElements];
    }

    _hasOpenNavPanel() {
      return Boolean(this._navGroups?.some((details) => details.open));
    }

    _isNavOpen() {
      return this.classList.contains('is-nav-open');
    }

    _handleScroll() {
      if (this._rafId !== null) return;

      this._rafId = window.requestAnimationFrame(() => {
        this._rafId = null;
        this._syncScrollState();
      });
    }

    _syncScrollState() {
      this.classList.toggle('is-scrolled', window.scrollY > 0);
      this._syncNavPanelGeometry();
    }

    _handleSearchTriggerClick(event) {
      if (!this._searchPanel || !this._searchInput) return;

      event.preventDefault();
      this._openSearch(event.currentTarget);
    }

    _handleSearchOverlayClick() {
      this._closeSearch();
    }

    _handleSearchCloseClick() {
      this._closeSearch();
    }

    _handleSearchInput() {
      if (!this._searchInput) return;

      const query = this._searchInput.value.trim();
      this._searchClear.hidden = query.length === 0;
      this._searchInput.setAttribute('aria-activedescendant', '');
      this._activeSuggestionIndex = -1;
      this._clearSuggestionResults();

      if (this._searchDebounceId !== null) {
        window.clearTimeout(this._searchDebounceId);
        this._searchDebounceId = null;
      }
      this._searchAbortController?.abort();
      this._searchAbortController = null;
      this._searchRequestSequence += 1;
      this._setSearchBusy(false);

      if (query.length < 2) {
        this._setSearchStatus('');
        return;
      }

      const requestSequence = this._searchRequestSequence;
      this._searchDebounceId = window.setTimeout(() => {
        this._searchDebounceId = null;
        this._fetchSuggestions(query, requestSequence);
      }, 200);
    }

    _handleSearchClearClick() {
      if (!this._searchInput) return;

      this._searchInput.value = '';
      this._handleSearchInput();
      this._searchInput.focus();
    }

    _handleSearchKeydown(event) {
      if (!this._searchPanel || !this._searchInput) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this._closeSearch();
        return;
      }

      if (event.key === 'Tab') {
        this._trapSearchFocus(event);
        return;
      }

      if (document.activeElement !== this._searchInput || !this._searchResults) return;

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const links = this._getSuggestionLinks();
        if (links.length === 0) return;

        event.preventDefault();
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        const nextIndex = this._activeSuggestionIndex + direction;
        this._setActiveSuggestion((nextIndex + links.length) % links.length);
      } else if (event.key === 'Enter' && this._activeSuggestionIndex >= 0) {
        const activeLink = this._getSuggestionLinks()[this._activeSuggestionIndex];
        if (!activeLink) return;

        event.preventDefault();
        activeLink.click();
      }
    }

    _openSearch(trigger) {
      if (this._isSearchOpen()) return;

      if (this._isNavOpen()) this._closeNav({ restoreFocus: false });
      if (this._hasOpenNavPanel()) this._closeNavGroups();

      if (this._isDrawerOpen()) {
        this._suppressCartFocusRestore = true;
        if (this._cartLinkFocusRafId !== null) {
          window.cancelAnimationFrame(this._cartLinkFocusRafId);
          this._cartLinkFocusRafId = null;
        }
        if (typeof $360 !== 'undefined' && typeof $360.hideHeaderCart === 'function') {
          $360.hideHeaderCart();
        }
      }

      this._lastSearchTrigger = trigger || this._searchTrigger;
      this.classList.add('is-search-open');
      this.closest('.site-header-section')?.classList.add('is-search-open');
      document.body.classList.add('ndev-site-search-open');
      this._searchPanel.hidden = false;
      this._searchPanel.removeAttribute('inert');
      this._searchPanel.setAttribute('aria-hidden', 'false');
      this._searchOverlay.hidden = false;
      this._searchClose.hidden = false;
      this._searchTrigger.setAttribute('aria-expanded', 'true');
      this._searchInput.focus({ preventScroll: true });
      this._scheduleSearchFocus();
    }

    _closeSearch({ restoreFocus = true } = {}) {
      if (!this._isSearchOpen()) return;

      if (this._searchDebounceId !== null) {
        window.clearTimeout(this._searchDebounceId);
        this._searchDebounceId = null;
      }
      this._searchAbortController?.abort();
      this._searchAbortController = null;
      this._searchRequestSequence += 1;
      this._clearSuggestionResults();
      this._setSearchBusy(false);
      this._searchInput.value = '';
      this._searchClear.hidden = true;
      this._setSearchStatus('');
      this._searchInput.setAttribute('aria-activedescendant', '');
      this._activeSuggestionIndex = -1;
      if (this._searchPanel.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      this._searchPanel.hidden = true;
      this._searchPanel.setAttribute('inert', '');
      this._searchPanel.setAttribute('aria-hidden', 'true');
      this._searchOverlay.hidden = true;
      this._searchClose.hidden = true;
      this._searchTrigger.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-search-open');
      this.closest('.site-header-section')?.classList.remove('is-search-open');
      document.body.classList.remove('ndev-site-search-open');

      if (restoreFocus) {
        this._lastSearchTrigger?.focus();
      }
      this._lastSearchTrigger = null;
    }

    _scheduleSearchFocus() {
      if (this._searchFocusRafId !== null) return;

      this._searchFocusRafId = window.requestAnimationFrame(() => {
        this._searchFocusRafId = null;
        if (this._isSearchOpen()) this._searchInput?.focus();
      });
    }

    _trapSearchFocus(event) {
      const focusableElements = this._getSearchFocusableElements();
      if (focusableElements.length === 0) {
        event.preventDefault();
        this._searchInput?.focus();
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      if (!this._searchPanel.contains(activeElement)) {
        event.preventDefault();
        (event.shiftKey ? lastElement : firstElement).focus();
      } else if (event.shiftKey && activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    _getSearchFocusableElements() {
      if (!this._searchPanel) return [];

      return Array.from(this._searchPanel.querySelectorAll(
        'a[href], button:not([disabled]):not([hidden]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((element) => element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true');
    }

    _getSuggestionLinks() {
      return this._searchResults ? Array.from(this._searchResults.querySelectorAll('.ndev-site-header__suggestion-link')) : [];
    }

    _setActiveSuggestion(index) {
      const links = this._getSuggestionLinks();
      if (links.length === 0) return;

      this._activeSuggestionIndex = index;
      links.forEach((link, linkIndex) => {
        const isActive = linkIndex === index;
        link.setAttribute('aria-selected', String(isActive));
        if (isActive) {
          const optionId = link.id;
          this._searchInput.setAttribute('aria-activedescendant', optionId);
          link.scrollIntoView({ block: 'nearest' });
        }
      });
    }

    async _fetchSuggestions(query, requestSequence) {
      let endpoint;

      try {
        endpoint = new URL(this.getAttribute('predictive-url'), window.location.origin);
      } catch (error) {
        this._setSearchStatus(this._searchPanel?.getAttribute('search-failed-message') || '');
        return;
      }

      if (endpoint.origin !== window.location.origin) {
        this._setSearchStatus(this._searchPanel?.getAttribute('search-failed-message') || '');
        return;
      }

      endpoint.searchParams.set('q', query);
      endpoint.searchParams.set('resources[type]', 'product');
      endpoint.searchParams.set('resources[limit]', '5');
      endpoint.searchParams.set('resources[options][unavailable_products]', 'hide');
      this._searchAbortController = new AbortController();
      this._setSearchBusy(true);

      try {
        const response = await fetch(endpoint.toString(), {
          headers: { Accept: 'application/json' },
          signal: this._searchAbortController.signal,
        });
        if (!response.ok) throw new Error(`Predictive search request failed: ${response.status}`);

        const payload = await response.json();
        if (requestSequence !== this._searchRequestSequence || !this._isSearchOpen()) return;

        const products = payload?.resources?.results?.products || payload?.resources?.products || [];
        this._renderSuggestions(products, query);
      } catch (error) {
        if (error?.name === 'AbortError' || requestSequence !== this._searchRequestSequence) return;
        this._clearSuggestionResults();
        this._setSearchStatus(this._searchPanel?.getAttribute('search-failed-message') || '');
      } finally {
        if (requestSequence === this._searchRequestSequence) {
          this._setSearchBusy(false);
          this._searchAbortController = null;
        }
      }
    }

    _renderSuggestions(products, query) {
      const validProducts = Array.isArray(products) ? products.filter((product) => product && product.available !== false).slice(0, 5) : [];
      this._clearSuggestionResults();

      if (validProducts.length === 0) {
        this._setSearchStatus(this._searchPanel?.getAttribute('no-results-message') || '');
        return;
      }

      validProducts.forEach((product, index) => {
        let productUrl;
        try {
          productUrl = new URL(product.url, window.location.origin);
        } catch (error) {
          return;
        }
        if (productUrl.origin !== window.location.origin) return;

        const item = document.createElement('li');
        item.setAttribute('role', 'presentation');
        const link = document.createElement('a');
        link.id = `${this._searchResults.id}-option-${index}`;
        link.className = 'ndev-site-header__suggestion-link';
        link.href = productUrl.href;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        const title = document.createElement('span');
        title.className = 'ndev-site-header__suggestion-title';
        this._appendHighlightedTitle(title, product.title || '', query);
        link.append(title);
        item.append(link);
        this._searchResults.append(item);
      });

      if (this._searchResults.children.length === 0) {
        this._setSearchStatus(this._searchPanel?.getAttribute('no-results-message') || '');
        return;
      }

      this._searchSuggestions.hidden = false;
      this._searchInput.setAttribute('aria-expanded', 'true');
      this._setSearchStatus('');
    }

    _appendHighlightedTitle(container, title, query) {
      const normalizedQuery = query.trim().toLocaleLowerCase();
      const normalizedTitle = title.toLocaleLowerCase();
      if (!normalizedQuery) {
        container.textContent = title;
        return;
      }

      let cursor = 0;
      let matchIndex = normalizedTitle.indexOf(normalizedQuery, cursor);
      if (matchIndex === -1) {
        container.textContent = title;
        return;
      }

      while (matchIndex !== -1) {
        if (matchIndex > cursor) {
          container.append(document.createTextNode(title.slice(cursor, matchIndex)));
        }
        const match = document.createElement('mark');
        match.className = 'ndev-site-header__suggestion-match';
        match.textContent = title.slice(matchIndex, matchIndex + normalizedQuery.length);
        container.append(match);
        cursor = matchIndex + normalizedQuery.length;
        matchIndex = normalizedTitle.indexOf(normalizedQuery, cursor);
      }

      if (cursor < title.length) {
        container.append(document.createTextNode(title.slice(cursor)));
      }
    }

    _clearSuggestionResults() {
      if (!this._searchResults) return;

      while (this._searchResults.firstChild) {
        this._searchResults.firstChild.remove();
      }
      this._searchSuggestions.hidden = true;
      this._searchInput?.setAttribute('aria-expanded', 'false');
      this._activeSuggestionIndex = -1;
    }

    _setSearchBusy(isBusy) {
      this._searchInput?.setAttribute('aria-busy', String(isBusy));
    }

    _setSearchStatus(message) {
      if (this._searchStatus) this._searchStatus.textContent = message;
    }

    _handleCartClick(event) {
      if (typeof $360 === 'undefined' || typeof $360.showHeaderCart !== 'function') return;

      event.preventDefault();
      if (this._isSearchOpen()) this._closeSearch({ restoreFocus: false });
      if (this._isNavOpen()) this._closeNav({ restoreFocus: false });
      if (this._hasOpenNavPanel()) this._closeNavGroups();
      $360.showHeaderCart();
    }

    _handleDocumentKeydown(event) {
      if (this._isSearchOpen()) {
        this._handleSearchKeydown(event);
        return;
      }

      if (this._isNavOpen()) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this._closeNav();
          return;
        }

        if (event.key === 'Tab') {
          this._trapNavFocus(event);
          return;
        }
      }

      if (this._navMediaQuery?.matches && this._hasOpenNavPanel() && event.key === 'Escape') {
        event.preventDefault();
        this._closeNavGroups();
        return;
      }

      if (!this._isDrawerOpen()) return;

      if (event.key === 'Escape') {
        if (typeof $360 === 'undefined' || typeof $360.hideHeaderCart !== 'function') return;

        event.preventDefault();
        $360.hideHeaderCart();
        return;
      }

      if (event.key !== 'Tab' || !this._cartDrawer) return;

      const focusableElements = Array.from(
        this._cartDrawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true');

      if (focusableElements.length === 0) {
        event.preventDefault();
        this._cartDrawer.focus();
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      if (!this._cartDrawer.contains(activeElement)) {
        event.preventDefault();
        (event.shiftKey ? lastElement : firstElement).focus();
      } else if (event.shiftKey && activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    _isDrawerOpen() {
      return Boolean(this._cartDrawer?.classList.contains('active'));
    }

    _isSearchOpen() {
      return this.classList.contains('is-search-open');
    }

    _syncDrawerState() {
      if (!this._cartLink || !this._cartDrawer) return;

      const isOpen = this._isDrawerOpen();
      if (isOpen && this._isSearchOpen()) {
        this._closeSearch({ restoreFocus: false });
      }
      if (isOpen && this._isNavOpen()) {
        this._closeNav({ restoreFocus: false });
      }
      this._cartLink.setAttribute('aria-expanded', String(isOpen));
      this._cartDrawer.setAttribute('aria-hidden', String(!isOpen));

      if (isOpen) {
        if (this._cartLinkFocusRafId !== null) {
          window.cancelAnimationFrame(this._cartLinkFocusRafId);
          this._cartLinkFocusRafId = null;
        }
        this._cartDrawer.removeAttribute('inert');
      } else {
        this._cartDrawer.setAttribute('inert', '');
      }

      if (isOpen && !this._drawerWasOpen) {
        this._shouldFocusDrawer = true;
      }

      if (isOpen && this._shouldFocusDrawer) {
        this._scheduleDrawerFocus();
      } else if (!isOpen && this._drawerWasOpen) {
        this._shouldFocusDrawer = false;
        if (this._suppressCartFocusRestore) {
          this._suppressCartFocusRestore = false;
        } else {
          this._scheduleCartLinkFocus();
        }
      }

      this._drawerWasOpen = isOpen;
    }

    _scheduleDrawerFocus() {
      if (this._drawerFocusRafId !== null) return;

      this._drawerFocusRafId = window.requestAnimationFrame(() => {
        this._drawerFocusRafId = null;
        const closeButton = this._cartDrawer?.querySelector('.header-cart-close');

        if (!closeButton || !this._isDrawerOpen()) return;
        if (!closeButton.getAttribute('aria-label')) {
          closeButton.setAttribute('aria-label', 'Close cart');
        }

        closeButton.focus();
        this._shouldFocusDrawer = false;
      });
    }

    _scheduleCartLinkFocus() {
      if (this._cartLinkFocusRafId !== null) return;

      this._cartLinkFocusRafId = window.requestAnimationFrame(() => {
        this._cartLinkFocusRafId = window.requestAnimationFrame(() => {
          this._cartLinkFocusRafId = null;
          if (!this._isDrawerOpen()) {
            this._cartLink?.focus();
          }
        });
      });
    }
  }

  if (!customElements.get('ndev-site-header')) {
    customElements.define('ndev-site-header', NdevSiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-x30-sale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-x30-sale';
    const ROOT_SELECTOR = '[data-ndev-x30-sale]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      // 初始化逻辑（建议事件绑定都挂在 root 上，并在 destroy 里移除）

      controllers.set(root, {
        root: root,
        destroy: function () {
          // 清理事件监听器、定时器等（注意移除你在 init 里绑定的监听）
          try {
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-instagram-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nw-instagram-reels')) {
    class NwInstagramReels extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;

        this.onScroll = () => this.updateArrows();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev?.addEventListener('click', () => this.scrollByCard(-1));
        this.next?.addEventListener('click', () => this.scrollByCard(1));
        this.updateArrows();
        this.setupVideos();
        this.setupDialog();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.observer?.disconnect();
        if (this.dialog?.open) this.closeReel();
      }

      // Cards open their reel in a pop-up instead of leaving the site.
      setupDialog() {
        this.dialog = this.querySelector('.nw-reels__dialog');
        this.dialogBody = this.querySelector('[data-dialog-body]');
        this.templates = [...this.querySelectorAll('template[data-reel-template]')];
        if (!this.dialog || !this.dialogBody || !this.templates.length) return;

        this.querySelectorAll('.nw-reels__card').forEach((card) => {
          card.addEventListener('click', () => {
            this.lastTrigger = card;
            this.openReel(Number(card.dataset.reelIndex) || 0);
          });
        });

        this.dialog.querySelector('[data-dialog-close]')?.addEventListener('click', () => this.closeReel());
        this.dialog.querySelector('[data-dialog-prev]')?.addEventListener('click', () => this.showReel(this.current - 1));
        this.dialog.querySelector('[data-dialog-next]')?.addEventListener('click', () => this.showReel(this.current + 1));

        // Click on the dark backdrop (outside the media) closes.
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog || event.target.classList.contains('nw-reels__dialog-inner')) this.closeReel();
        });
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.showReel(this.current - 1);
          if (event.key === 'ArrowRight') this.showReel(this.current + 1);
        });
        // Esc closes natively; make sure media stops and scroll unlocks.
        this.dialog.addEventListener('close', () => this.cleanupDialog());
      }

      openReel(index) {
        this.querySelectorAll('.nw-reels__video').forEach((video) => video.pause());
        this.showReel(index);
        document.documentElement.style.overflow = 'hidden';
        if (!this.dialog.open) this.dialog.showModal();
      }

      showReel(index) {
        const count = this.templates.length;
        this.current = ((index % count) + count) % count;
        this.dialogBody.querySelectorAll('video').forEach((video) => video.pause());
        this.dialogBody.replaceChildren(this.templates[this.current].content.cloneNode(true));
        const video = this.dialogBody.querySelector('video');
        if (video) {
          video.muted = false;
          const play = video.play();
          if (play && play.catch) {
            play.catch(() => {
              video.muted = true;
              video.play().catch(() => {});
            });
          }
        }
      }

      closeReel() {
        if (this.dialog.open) this.dialog.close();
        else this.cleanupDialog();
      }

      cleanupDialog() {
        this.dialogBody?.querySelectorAll('video').forEach((video) => video.pause());
        this.dialogBody?.replaceChildren();
        document.documentElement.style.overflow = '';
        this.lastTrigger?.focus({ preventScroll: true });
      }

      scrollByCard(direction) {
        const card = this.track.querySelector('.nw-reels__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
        this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      updateArrows() {
        if (!this.prev || !this.next) return;
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max;
      }

      // Muted reels play only while mostly on screen; nothing loads until then.
      setupVideos() {
        const videos = [...this.querySelectorAll('.nw-reels__video')];
        if (!videos.length || !('IntersectionObserver' in window)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              const card = video.closest('.nw-reels__card');
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6 && !document.hidden) {
                video.muted = true;
                const play = video.play();
                if (play && play.then) play.then(() => card?.classList.add('is-playing')).catch(() => {});
              } else {
                video.pause();
                card?.classList.remove('is-playing');
              }
            });
          },
          { threshold: [0, 0.6] }
        );
        videos.forEach((video) => this.observer.observe(video));
      }
    }

    customElements.define('nw-instagram-reels', NwInstagramReels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-in-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.__nwInbox) return;
      root.__nwInbox = true;
      var items = root.querySelectorAll('.nw-inbox__item');
      var detail = root.querySelector('.nw-inbox__detail');
      if (!detail) return;
      var imageBox = detail.querySelector('.nw-inbox__detail-image');

      function select(item) {
        items.forEach(function (el) { el.setAttribute('aria-pressed', String(el === item)); });
        detail.querySelector('.nw-inbox__detail-title').textContent = item.dataset.title || '';
        detail.querySelector('.nw-inbox__detail-desc').textContent = item.dataset.desc || '';
        imageBox.innerHTML = '';
        if (item.dataset.image) {
          var img = new Image();
          img.src = item.dataset.image;
          img.alt = item.dataset.title || '';
          imageBox.appendChild(img);
        }
      }

      items.forEach(function (item) {
        item.addEventListener('click', function () { select(item); });
      });
      root.addEventListener('shopify:block:select', function (event) {
        var item = event.target.closest('.nw-inbox__item');
        if (item) select(item);
      });
    }

    function scan() { document.querySelectorAll('[data-nw-inbox]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-support"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.__nwSupport) return;
      root.__nwSupport = true;
      var buttons = root.querySelectorAll('[data-tab]');
      var select = root.querySelector('.nw-support__select select');

      function show(name) {
        root.querySelectorAll('[data-panel]').forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-panel') !== name;
        });
        buttons.forEach(function (button) {
          button.setAttribute('aria-selected', String(button.getAttribute('data-tab') === name));
        });
        if (select) select.value = name;
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () { show(button.getAttribute('data-tab')); });
      });
      if (select) select.addEventListener('change', function () { show(select.value); });

      // Open the right tab when a block is selected in the theme editor.
      root.addEventListener('shopify:block:select', function (event) {
        var panel = event.target.closest('[data-panel]');
        if (panel) show(panel.getAttribute('data-panel'));
        if (event.target.tagName === 'DETAILS') event.target.open = true;
      });
    }

    function scan() { document.querySelectorAll('[data-nw-support]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-pdp-text-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.__nwPtv) return;
      root.__nwPtv = true;
      var video = root.querySelector('video');
      if (!video) return;
      var toggle = root.querySelector('.nw-ptv__toggle');
      var userPaused = false;

      video.addEventListener('playing', function () { root.classList.add('is-playing'); });
      video.addEventListener('pause', function () { root.classList.remove('is-playing'); });

      function play() {
        if (video.dataset.src) {
          video.src = video.dataset.src;
          video.removeAttribute('data-src');
        }
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      }

      toggle.addEventListener('click', function () {
        if (video.paused) { userPaused = false; play(); }
        else { userPaused = true; video.pause(); }
      });

      if (!('IntersectionObserver' in window)) return play();
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { if (!userPaused) play(); }
          else if (!video.paused) video.pause();
        });
      }, { rootMargin: '200px 0px' }).observe(root);
    }

    function scan() { document.querySelectorAll('[data-nw-ptv]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-banner"] && !Shopify.designMode) return;
  try {
    
    
  class NdevPageBanner extends BaseElement {
    init() {
      this.dispose();

      this.viewport = this.querySelector('.page-banner__swiper');
      this.track = this.querySelector('.swiper-wrapper');
      this.verticalTabs = this.querySelector('.page-banner__vertical-tabs');
      this.horizontalTabs = this.querySelector('.page-banner__horizontal-tabs');
      this.horizontalTabsPc = this.querySelector('.page-banner__horizontal-tabs-pc');
      this.navigation = this.querySelector('.page-banner__navigation');
      this.previousButton = this.querySelector('.page-banner__navigation-button--prev');
      this.nextButton = this.querySelector('.page-banner__navigation-button--next');
      this.status = this.querySelector('.page-banner__status');
      this.listeners = [];
      this.swiper = null;
      this.waitFrame = null;
      this.resizeFrame = null;
      this.adaptiveHeightFrame = null;
      this.inView = !('IntersectionObserver' in window);
      this.activeIndex = 0;
      this.autoplayEnabled = this.getAttribute('autoplay') === 'true';
      this.autoplayDelay = Math.max(1000, Number(this.getAttribute('autoplay-delay')) || 5000);
      this.loopEnabled = this.getAttribute('loop') === 'true';
      this.showPagination = this.getAttribute('show-pagination') === 'true';
      this.showNavigation = this.getAttribute('show-navigation') === 'true';
      this.paginationVariant = this.getAttribute('pagination-variant') || 'tabs';
      this.adaptiveHeightEnabled = this.getAttribute('adaptive-height') === 'true';
      this.pcBannerHeight = Number(this.getAttribute('pc-banner-height'));
      this.bannerSection = this.closest('.page-banner');
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.viewport || !this.track) return;

      this.slideHosts = Array.from(this.track.children).filter(
        (child) => child.nodeType === Node.ELEMENT_NODE && !['STYLE', 'SCRIPT', 'TEMPLATE', 'LINK'].includes(child.tagName)
      );
      this.slideCount = this.slideHosts.length;
      this.loopEnabled = this.loopEnabled && this.slideCount > 1;
      this.setupAdaptiveHeight();

      this.editorSelectedBlock = null;

      this.bindActions();
      this.observeVisibility();
      this.on(document, 'visibilitychange', () => this.syncRuntimeState());
      this.on(document, 'shopify:block:select', (event) => this.handleBlockSelect(event));
      this.on(document, 'shopify:block:deselect', (event) => this.handleBlockDeselect(event));
      this.on(window, 'resize', () => this.handleResize());

      if (this.motionQuery.addEventListener) {
        this.on(this.motionQuery, 'change', () => this.handleMotionChange());
      } else if (this.motionQuery.addListener) {
        this.motionListener = () => this.handleMotionChange();
        this.motionQuery.addListener(this.motionListener);
      }

      this.buildPagination();
      this.hideControls();
      this.syncSlideState(0);

      if (this.slideCount <= 1) {
        this.removeAttribute('role');
        this.removeAttribute('aria-roledescription');
        this.removeAttribute('aria-label');
        this.setAttribute('ready', '');
        return;
      }

      this.setAttribute('role', 'region');
      this.setAttribute('aria-roledescription', 'carousel');
      this.setAttribute('aria-label', 'Banner carousel');
      this.waitForSwiper();
    }

    dispose() {
      if (this.waitFrame) cancelAnimationFrame(this.waitFrame);
      if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
      if (this.adaptiveHeightFrame) cancelAnimationFrame(this.adaptiveHeightFrame);
      this.waitFrame = null;
      this.resizeFrame = null;
      this.adaptiveHeightFrame = null;

      if (this.adaptiveHeightObserver) this.adaptiveHeightObserver.disconnect();
      this.adaptiveHeightObserver = null;

      if (this.bannerSection) {
        this.bannerSection.style.removeProperty('--page-banner-adaptive-content-min-height');
      }
      this.querySelectorAll('.page-banner__slide').forEach((slide) => {
        slide.style.removeProperty('--page-banner-scaled-content-padding-top');
      });
      this.adaptiveHeightRunId = (this.adaptiveHeightRunId || 0) + 1;

      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      this.intersectionObserver = null;

      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler, options }) => {
          target.removeEventListener(type, handler, options);
        });
      }
      this.listeners = [];

      if (this.motionListener && this.motionQuery && this.motionQuery.removeListener) {
        this.motionQuery.removeListener(this.motionListener);
      }
      this.motionListener = null;

      if (this.swiper && this.swiper.destroy) this.swiper.destroy(true, true);
      this.swiper = null;

      // 背景视频由 ndev-page-banner-slide 自管，控制器不再集中暂停

      this.editorSelectedBlock = null;
      this.classList.remove('is-autoplaying', 'is-autoplay-runtime-paused', 'is-reduced-motion');
      this.removeAttribute('ready');
    }

    on(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      this.listeners.push({ target, type, handler, options });
    }

    getSlide(host) {
      // Block tag: null 后 host 即 `.page-banner__slide`，无 Shopify wrapper 层
      return host && host.matches('.page-banner__slide') ? host : null;
    }

    setupAdaptiveHeight() {
      if (
        !this.adaptiveHeightEnabled
        || !this.bannerSection
        || !Number.isFinite(this.pcBannerHeight)
        || this.pcBannerHeight <= 0
      ) return;

      const contentInners = this.slideHosts
        .map((host) => {
          const slide = this.getSlide(host);
          return slide && slide.querySelector('.page-banner__content-inner');
        })
        .filter(Boolean);

      const runId = this.adaptiveHeightRunId;
      if ('ResizeObserver' in window && contentInners.length) {
        this.adaptiveHeightObserver = new ResizeObserver(() => {
          if (this.adaptiveHeightRunId === runId) this.scheduleAdaptiveHeight();
        });
        contentInners.forEach((contentInner) => this.adaptiveHeightObserver.observe(contentInner));
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (this.isConnected && this.adaptiveHeightRunId === runId) this.scheduleAdaptiveHeight();
        });
      }

      this.scheduleAdaptiveHeight();
    }

    scheduleAdaptiveHeight() {
      if (!this.adaptiveHeightEnabled || !this.bannerSection) return;
      if (this.adaptiveHeightFrame) return;
      this.adaptiveHeightFrame = requestAnimationFrame(() => {
        this.adaptiveHeightFrame = null;
        this.syncAdaptiveHeight();
      });
    }

    syncAdaptiveHeight() {
      if (!this.adaptiveHeightEnabled || !this.bannerSection) return;

      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      if (!isDesktop) {
        this.bannerSection.style.removeProperty('--page-banner-adaptive-content-min-height');
        this.clearScaledContentPadding();
        return;
      }

      let requiredBannerHeight = 0;
      this.slideHosts.forEach((host) => {
        const slide = this.getSlide(host);
        const measurement = this.getAdaptiveContentMeasurement(slide);
        if (!measurement || measurement.contentHeight <= 0) return;

        let slideRequiredHeight = measurement.contentHeight;
        if (!measurement.centered) {
          if (measurement.paddingTop >= this.pcBannerHeight) {
            slideRequiredHeight = measurement.paddingTop + measurement.contentHeight;
          } else {
            const remainingRatio = 1 - (measurement.paddingTop / this.pcBannerHeight);
            slideRequiredHeight = measurement.contentHeight / remainingRatio;
          }
        }

        if (Number.isFinite(slideRequiredHeight)) {
          requiredBannerHeight = Math.max(requiredBannerHeight, slideRequiredHeight);
        }
      });

      if (requiredBannerHeight > 0 && Number.isFinite(requiredBannerHeight)) {
        this.bannerSection.style.setProperty(
          '--page-banner-adaptive-content-min-height',
          `${requiredBannerHeight}px`
        );
      } else {
        this.bannerSection.style.removeProperty('--page-banner-adaptive-content-min-height');
      }

      const bannerHeight = this.bannerSection.getBoundingClientRect().height;
      if (!Number.isFinite(bannerHeight) || bannerHeight <= 0) {
        this.clearScaledContentPadding();
        return;
      }

      this.querySelectorAll('.page-banner__slide').forEach((slide) => {
        const measurement = this.getAdaptiveContentMeasurement(slide);
        if (!measurement || measurement.centered || measurement.contentHeight <= 0) {
          slide.style.removeProperty('--page-banner-scaled-content-padding-top');
          return;
        }

        const scaledPadding = measurement.paddingTop * bannerHeight / this.pcBannerHeight;
        const availablePadding = Math.max(0, bannerHeight - measurement.contentHeight);
        const safePadding = Math.max(0, Math.min(scaledPadding, availablePadding));
        slide.style.setProperty('--page-banner-scaled-content-padding-top', `${safePadding}px`);
      });
    }

    getAdaptiveContentMeasurement(slide) {
      if (!slide) return null;
      const slideContent = slide.querySelector('.page-banner__slide-content');
      const contentInner = slide.querySelector('.page-banner__content-inner');
      if (!slideContent || !contentInner) return null;

      const contentHeight = Math.max(
        contentInner.getBoundingClientRect().height,
        contentInner.scrollHeight
      );
      const paddingTop = parseFloat(getComputedStyle(slide).getPropertyValue('--pb-content-padding-top'));
      return {
        centered: getComputedStyle(slide).getPropertyValue('--pb-v-align').trim() === 'center',
        contentHeight: Number.isFinite(contentHeight) ? Math.max(0, contentHeight) : 0,
        paddingTop: Number.isFinite(paddingTop) ? Math.max(0, paddingTop) : 0
      };
    }

    clearScaledContentPadding() {
      this.querySelectorAll('.page-banner__slide').forEach((slide) => {
        slide.style.removeProperty('--page-banner-scaled-content-padding-top');
      });
    }

    buildPagination() {
      const containers = [this.verticalTabs, this.horizontalTabs, this.horizontalTabsPc].filter(Boolean);
      containers.forEach((container) => {
        container.replaceChildren();
        container.hidden = true;
        container.style.setProperty('--count', this.slideCount);
      });

      if (!this.showPagination || this.slideCount <= 1) return;

      this.slideHosts.forEach((host, index) => {
        const slide = this.getSlide(host);
        const title = (slide && slide.getAttribute('data-tab-title')) || `Slide ${index + 1}`;

        if (this.verticalTabs && this.paginationVariant === 'tabs') {
          this.verticalTabs.appendChild(this.createPaginationButton('page-banner__vertical-tab', title, index, true));
        }

        if (this.horizontalTabsPc && this.paginationVariant === 'tabs_pc_horizontal') {
          const button = this.createPaginationButton('page-banner__horizontal-tab-pc', title, index, false);
          const label = document.createElement('span');
          label.className = 'page-banner__horizontal-tab-pc-title';
          label.textContent = title;
          button.appendChild(label);
          this.horizontalTabsPc.appendChild(button);
        }

        if (this.horizontalTabs) {
          this.horizontalTabs.appendChild(this.createPaginationButton('page-banner__horizontal-tab', title, index, false));
        }
      });
    }

    createPaginationButton(className, title, index, showText) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = className;
      button.setAttribute('aria-label', `Show ${title}`);
      button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      if (showText) button.textContent = title;
      this.on(button, 'click', () => {
        if (!this.swiper) return;
        if (this.loopEnabled && this.swiper.slideToLoop) this.swiper.slideToLoop(index);
        else this.swiper.slideTo(index);
        this.announceSlide(index);
      });
      return button;
    }

    waitForSwiper() {
      const startedAt = performance.now();
      const check = () => {
        if (!this.isConnected) return;
        if (window.Swiper) {
          this.createSwiper();
          return;
        }
        if (performance.now() - startedAt < 5000) {
          this.waitFrame = requestAnimationFrame(check);
        }
      };
      check();
    }

    createSwiper() {
      if (this.swiper || !window.Swiper || this.slideCount <= 1) return;

      const reducedMotion = this.motionQuery.matches;
      this.classList.toggle('is-reduced-motion', reducedMotion);

      this.swiper = new window.Swiper(this.viewport, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: this.loopEnabled,
        simulateTouch: true,
        allowTouchMove: true,
        speed: reducedMotion ? 0 : 300,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        slideClass: 'page-banner__slide',
        autoplay: this.autoplayEnabled
          ? {
              delay: this.autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
              stopOnLastSlide: !this.loopEnabled
            }
          : false,
        on: {
          init: (swiper) => this.handleSlideChange(this.getSwiperIndex(swiper), swiper),
          slideChange: (swiper) => this.handleSlideChange(this.getSwiperIndex(swiper), swiper)
        }
      });

      this.setAttribute('ready', '');
      this.showControls();
      this.syncAutoplay();
      this.scheduleAdaptiveHeight();
    }

    getSwiperIndex(swiper = this.swiper) {
      if (swiper && Number.isFinite(swiper.realIndex)) return swiper.realIndex;
      if (swiper && Number.isFinite(swiper.activeIndex)) return swiper.activeIndex;
      return 0;
    }

    handleSlideChange(index, swiper = this.swiper) {
      this.activeIndex = index;
      this.syncSlideState(index);
      this.syncPagination(index);
      this.syncNavigation(swiper);
      if (this.swiper) this.syncAutoplay();
      this.restartProgress();
    }

    syncNavigation(swiper = this.swiper) {
      const navigationRequired = this.showNavigation && this.slideCount > 1 && swiper;
      const canWrap = Boolean(swiper && swiper.params && (swiper.params.loop || swiper.params.rewind));
      if (this.previousButton) this.previousButton.hidden = !navigationRequired || (!canWrap && swiper.isBeginning);
      if (this.nextButton) this.nextButton.hidden = !navigationRequired || (!canWrap && swiper.isEnd);
    }

    syncPagination(activeIndex) {
      const mappings = [
        ['.page-banner__vertical-tab', 'page-banner__vertical-tab--active'],
        ['.page-banner__horizontal-tab', 'page-banner__horizontal-tab--active'],
        ['.page-banner__horizontal-tab-pc', 'page-banner__horizontal-tab-pc--active']
      ];

      mappings.forEach(([selector, activeClass]) => {
        this.querySelectorAll(selector).forEach((button, index) => {
          const active = index === activeIndex;
          button.classList.toggle(activeClass, active);
          button.setAttribute('aria-current', active ? 'true' : 'false');
        });
      });

      if (this.verticalTabs) {
        this.verticalTabs.style.setProperty('--top', `${activeIndex * (19.2 + 18)}px`);
      }
    }

    syncSlideState(activeIndex) {
      if (!this.slideHosts) return;

      this.slideHosts.forEach((host, index) => {
        const active = index === activeIndex;
        const slide = this.getSlide(host);
        host.toggleAttribute('inert', !active);
        host.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (slide && slide !== host) {
          slide.toggleAttribute('inert', !active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        }
        // 背景媒体播放/暂停由 ndev-page-banner-slide 依据上述活性属性自治处理
      });
    }

    shouldAutoplay() {
      return Boolean(
        this.swiper
        && this.swiper.autoplay
        && this.autoplayEnabled
        && !this.motionQuery.matches
        && this.inView
        && !document.hidden
        && !this.editorSelectedBlock
        && (this.loopEnabled || !this.swiper.isEnd)
      );
    }

    syncAutoplay() {
      if (!this.swiper || !this.swiper.autoplay) {
        this.classList.remove('is-autoplaying', 'is-autoplay-runtime-paused');
        return;
      }

      const shouldRun = this.shouldAutoplay();
      if (shouldRun) {
        if (!this.swiper.autoplay.running) this.swiper.autoplay.start();
      } else if (this.swiper.autoplay.running) {
        this.swiper.autoplay.stop();
      }

      this.classList.toggle('is-autoplaying', shouldRun);
      this.classList.toggle('is-autoplay-runtime-paused', this.autoplayEnabled && !shouldRun);
    }

    restartProgress() {
      const shouldRun = this.shouldAutoplay();
      this.classList.remove('is-autoplaying');
      void this.offsetWidth;
      this.classList.toggle('is-autoplaying', shouldRun);
    }

    syncRuntimeState() {
      this.syncAutoplay();
      this.syncSlideState(this.activeIndex || 0);
      if (this.shouldAutoplay()) this.restartProgress();
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) return;
      this.intersectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const wasInView = this.inView;
        this.inView = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0);
        if (wasInView !== this.inView) this.syncRuntimeState();
      }, { threshold: [0, 0.01] });
      this.intersectionObserver.observe(this);
    }

    handleResize() {
      if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
      this.resizeFrame = requestAnimationFrame(() => {
        if (this.swiper && this.swiper.update) this.swiper.update();
        this.syncSlideState(this.activeIndex || 0);
        this.scheduleAdaptiveHeight();
      });
    }

    handleMotionChange() {
      const reducedMotion = this.motionQuery.matches;
      this.classList.toggle('is-reduced-motion', reducedMotion);
      if (this.swiper) this.swiper.params.speed = reducedMotion ? 0 : 300;
      this.syncRuntimeState();
    }

    bindActions() {
      // 按钮动作分发与 Slide 整块跳转分别由子级自定义元素
      // ndev-page-banner-button / ndev-page-banner-slide 自治处理，控制器不再委托。

      this.on(this.previousButton, 'click', () => {
        if (!this.swiper) return;
        this.swiper.slidePrev();
        this.announceSlide(this.getSwiperIndex());
      });

      this.on(this.nextButton, 'click', () => {
        if (!this.swiper) return;
        this.swiper.slideNext();
        this.announceSlide(this.getSwiperIndex());
      });
    }

    announceSlide(index) {
      if (!this.status || !this.slideHosts[index]) return;
      const slide = this.getSlide(this.slideHosts[index]);
      const title = (slide && slide.getAttribute('data-tab-title')) || `Slide ${index + 1}`;
      this.status.textContent = `${title}, slide ${index + 1} of ${this.slideCount}`;
    }

    showControls() {
      if (this.slideCount <= 1) return;
      if (this.showPagination) {
        if (this.paginationVariant === 'tabs' && this.verticalTabs) this.verticalTabs.hidden = false;
        if (this.paginationVariant === 'tabs_pc_horizontal' && this.horizontalTabsPc) this.horizontalTabsPc.hidden = false;
        if (this.horizontalTabs) this.horizontalTabs.hidden = false;
      }
      if (this.navigation) this.navigation.hidden = !this.showNavigation && !this.showPagination;
      this.syncNavigation();
    }

    hideControls() {
      if (this.verticalTabs) this.verticalTabs.hidden = true;
      if (this.horizontalTabs) this.horizontalTabs.hidden = true;
      if (this.horizontalTabsPc) this.horizontalTabsPc.hidden = true;
      if (this.navigation) this.navigation.hidden = true;
      if (this.previousButton) this.previousButton.hidden = true;
      if (this.nextButton) this.nextButton.hidden = true;
    }

    handleBlockSelect(event) {
      if (!event || !event.target || !this.contains(event.target) || !this.swiper) return;
      let current = event.target.nodeType === Node.ELEMENT_NODE ? event.target : event.target.parentElement;

      while (current && current !== this) {
        const index = this.slideHosts.indexOf(current);
        if (index >= 0) {
          // 编辑该 Block（或其内部子 Block）期间保持该 Slide 常显，停止自动轮播
          this.editorSelectedBlock = event.target;
          if (this.loopEnabled && this.swiper.slideToLoop) this.swiper.slideToLoop(index);
          else this.swiper.slideTo(index);
          this.syncAutoplay();
          return;
        }
        current = current.parentElement;
      }
    }

    handleBlockDeselect(event) {
      if (!event || !event.target || !this.contains(event.target)) return;
      if (event.target !== this.editorSelectedBlock) return;

      this.editorSelectedBlock = null;
      this.syncRuntimeState();
    }
  }

  if (!customElements.get('ndev-page-banner')) {
    customElements.define('ndev-page-banner', NdevPageBanner);
  }

  

  } catch(e) { console.error(e); }
})();
})();
